// function checkAndClearLocalStorageIfCartEmpty() {
//   fetch('/cart.js')
//     .then(res => res.json())
//     .then(cart => {
//       // console.log("cart.items.length",cart.items.length);
//       if (cart.items.length == 0) {
//         // Remove the key from localStorage when cart is empty
//         localStorage.removeItem('selectedProductData');
//       }
//     })
//     .catch(error => {
//       console.error('Error checking cart:', error);
//     });
// }
// checkAndClearLocalStorageIfCartEmpty();


//  Deep clone + safe merge helpers
function deepClone(obj) {
  try {
    if (typeof structuredClone === 'function') return structuredClone(obj);
  } catch (err) {}
  return JSON.parse(JSON.stringify(obj));
}

function mergeDraftWithExisting(existing, draft) {
  const merged = existing.map(item => deepClone(item));

  draft.forEach((rawDraft) => {
    const draftItem = deepClone(rawDraft);
    const draftVariantId = draftItem?.mainProduct?.variant_id || draftItem?.mainProduct?.variantId || null;

    const existingIndex = merged.findIndex((item) => {
      const existingVariantId = item?.mainProduct?.variant_id || item?.mainProduct?.variantId || null;
      return existingVariantId && draftVariantId && existingVariantId.toString() === draftVariantId.toString();
    });

    if (existingIndex !== -1) {
      merged[existingIndex] = {
        ...merged[existingIndex],
        ...draftItem,
        dimensions: Array.isArray(draftItem.dimensions) ? deepClone(draftItem.dimensions) : [],
        hardwareProduct: draftItem.hardwareProduct ? deepClone(draftItem.hardwareProduct) : null,
      };
    } else {
      merged.push(draftItem);
    }
  });

  return merged;
}


document.addEventListener("DOMContentLoaded", () => {
  var orderForm = document.querySelector(".order-form-section.order-form-page");
  if(orderForm){
    // START -- on change color and style set correct iamge and varinat id to product
    var styleSelect = document.querySelector('.pro-selector-content .pro-selector-type select');
    var selectedColorInput = document.querySelector('.pro-selector-content .pro-option-colors .swatch-input__input:checked');
    document.querySelector('.pro-selector-content .pro-option-colors .swatch-input__input').click();
    function toHandle(str) {
      return str
        .trim()
        .replace(/[^\w\s-]/g, '') // remove special characters
        .replace(/\s+/g, '-');   // replace spaces with dashes
    }
      
    function updateBanner(styleSelect, selectedColorInput) {
      // console.log("updateBanner>>>>",styleSelect,"selectedColorInput",selectedColorInput);
      if(selectedColorInput == undefined) return;
      
      // const styleImage = document.getElementById("style-image");
      // const colorImage = document.getElementById("color-image");
      const styleImage = document.querySelectorAll("#style-image");
      const colorImage = document.querySelectorAll("#color-image");
    
      const selectedStyle = styleSelect?.value?.trim();
      const selectedColor = selectedColorInput?.value?.trim();

      // Case 1: Nothing selected or only color selected
      if (!selectedStyle) {
        // styleImage.style.display = "block";
        // colorImage.style.display = "none";
        styleImage.forEach(img => {
          img.style.display = "block";
        });
        colorImage.forEach(img => {
          img.style.display = "none";
        });
        return;
      }
    
      // Case 2: Style selected, color not selected
      // console.log("selectedColorInput::::::::::",selectedColorInput)
      if (document.querySelector('.pro-selector-content .pro-selector-type select').value != "" && document.querySelector('.pro-selector-content .pro-option-colors .swatch-input__input:checked') == null) {
        // styleImage.style.display = "none";
        // colorImage.style.display = "block";
        styleImage.forEach(img => {
          img.style.display = "none";
        });
        colorImage.forEach(img => {
          img.style.display = "block";
        });
        return;
      }
    
      // Case 3: Both selected — show final combo image
      // console.log("selectedStyle",selectedStyle);
      const styleHandle = toHandle(selectedStyle);
      // console.log("styleHandle",styleHandle);
      const colorHandle = toHandle(selectedColor);
      const finalHandle = `${styleHandle}_${colorHandle}`;
      const fileName = `${finalHandle}.png`;
      const imageUrl = `https://cdn.shopify.com/s/files/1/0690/5489/0157/files/${fileName}`;
    
      // document.querySelectorAll(".order-form-image-main img").forEach((img) => {
      //   img.src = imageUrl;
      // });

      if (document.querySelector('.pro-selector-content .pro-selector-type select').value != "" && document.querySelector('.pro-selector-content .pro-option-colors .swatch-input__input:checked') != "") {
        // styleImage.style.display = "none";
        // colorImage.style.display = "none";
        styleImage.forEach(img => {
          img.style.display = "none";
        });
        colorImage.forEach(img => {
          img.style.display = "none";
        });
        document.querySelectorAll("[data-pro-type][data-pro-color]").forEach(img => {
          img.style.display = "block";
          img.src = imageUrl;
        });
        // document.querySelector("[data-pro-type][data-pro-color]").style.display = block;
        // document.querySelector("[data-pro-type][data-pro-color]").src = imageUrl;
      }
    }

    updateBanner(styleSelect,selectedColorInput);
    
    function updateProductButtons(styleSelect, colorInput) {
        var selectedStyle = styleSelect?.value?.trim();
        var selectedColor = colorInput?.value?.trim() || null;
        
      // console.log("selected style",selectedStyle);
      // console.log("selectedColor",selectedColor);
      document.querySelectorAll('.selection-list .product-item').forEach(item => {
        const button = item.querySelector('.product-item-button button');
        const imageElem = item.querySelector(".product-image img");
        const variantsJson = item.getAttribute('data-variants');
        const variants = JSON.parse(variantsJson);
      
        const matchedVariant = variants.find(variant => {
          return (
            variant.option1 === selectedStyle && 
            variant.option2 === selectedColor
          );
        });
        if (matchedVariant && matchedVariant.available) {
          if(matchedVariant.featured_image){
            imageElem.src = matchedVariant.featured_image.src;
          }
          updateBanner(styleSelect, colorInput);
          button.setAttribute('data-variant-id', matchedVariant.id);
          button.textContent = 'Add To Cart';
        } else {
          updateBanner();
          button.removeAttribute('data-variant-id',matchedVariant);
          // button.textContent = 'Out of Stock';
          // if(document.querySelector('.pro-option-colors .swatch-input__input:checked') != null) button.setAttribute('disabled', 'disabled');
        }
      });
    }
    updateProductButtons(styleSelect,selectedColorInput);
          
    function updateColorSwatchAvailability(styleSelect) {
      const selectedStyle = styleSelect.value;
      if (!selectedStyle) return;
      const swatches = orderForm.querySelectorAll('.pro-selector-content .pro-option-colors .swatch-input__input');
      swatches.forEach(input => {

        const colorValue = input.value;
        let isAvailable = false;
        var imageUrl = '';

        // Check all product items for at least one matching variant
        document.querySelectorAll('.product-item').forEach(item => {
          const variantsJson = item.getAttribute('data-variants');
          const variants = JSON.parse(variantsJson);
          
          const match = variants.find(variant =>
            variant.option1 === selectedStyle &&
            variant.option2 === colorValue &&
            variant.available
          );

          if (match) {
            isAvailable = true;
          }
          if(match && match.metafields.door_image){
            // console.log("match",match);
            imageUrl = match.metafields.door_image;
          }
        });

        // Toggle disabled class
        if (isAvailable) {
          const label = input.nextElementSibling;
          const tooltip = label.querySelector('.style-tooltip');

          let sImage = label.querySelector('.swatch-image img');
          sImage.src = imageUrl;
          
          if (tooltip) {
            // Tooltip exists, so find the img element inside and update the src
            const swatchImg = tooltip.querySelector('img');
            if (swatchImg) {
              swatchImg.src = imageUrl;
            }
          } else {
            const newTooltip = document.createElement('span');
            newTooltip.classList.add('style-tooltip','hidden');
            
            const newImg = document.createElement('img');
            newImg.width = ''; // Set the desired width
            newImg.height = ''; // Set the desired height
            newImg.src = imageUrl; // Set the src to the new image URL
            
            // Append the img to the tooltip, and the tooltip to the label
            newTooltip.appendChild(newImg);
            label.appendChild(newTooltip);
          }  
          input.classList.remove('disabled');
        } else {
          const label = input.nextElementSibling;
          const swatchSpan = label.querySelector('.style-tooltip');
          if(swatchSpan) swatchSpan.remove();
            
          input.classList.add('disabled');
        }
      });
    }
  
    //  pop-up msg if product is already added with same variant 
    function checkIfHardwareExists() {
      const selectedColorInput = document.querySelector('.pro-selector-content .pro-option-colors .swatch-input__input:checked');
      if(selectedColorInput){
        const selectedColor = selectedColorInput?.value;
        const styleSelects = document.querySelector('.pro-selector-content .pro-selector-type select');
        const selectedStyles = styleSelects?.value;
        const matchedItem = allSelectedProducts && allSelectedProducts.find(product => {
          return product.mainProduct &&
          product.mainProduct.color === selectedColor &&
          product.mainProduct.style === selectedStyles;
        });
        const validationPopup = document.querySelector('.custom-form-popup.type-validation');
        // console.log("matchedItem",matchedItem);
        if (!matchedItem && localStorage.selectedProductData != undefined && localStorage.selectedProductData != "[]") {
          if (validationPopup) {
            // validationPopup.style.display = "block";
            validationPopup.classList.add('active');
          }
          return true;
        } else {
          if (validationPopup) {}
          return false;
        }
      }
    }

    // disable color-paint radio button 
    function handlePaintReadyDisabling(selectedColorValue) {
      const yesRadio = document.getElementById('color-Paint-yes');
      const noRadio = document.getElementById('color-Paint-no');
      const paintOptionContainer = document.querySelector('.pro-option-color-Paint.product-form__input');
      if (!yesRadio || !noRadio || !paintOptionContainer) return;
      if (selectedColorValue === "Paint-Ready") {
        yesRadio.disabled = true;
        noRadio.disabled = true;
        paintOptionContainer.classList.add('select-color-paint');
      } else {
        yesRadio.disabled = false;
        noRadio.disabled = false;
        paintOptionContainer.classList.remove('select-color-paint');
      }
    }
    // on page reload

    if (selectedColorInput) {
      handlePaintReadyDisabling(selectedColorInput.value);
    }
    // handlePaintReadyDisabling(selectedColorValue);
  
    const mainSelector = orderForm.querySelector(".pro-selector-content .pro-selector-type select");
    const colorSwatches = orderForm.querySelectorAll('.pro-selector-content .pro-option-colors .swatch-input__input');
    const clrinput = document.querySelector('.pro-option-colors.product-form__input');
    colorSwatches.forEach((input) => {
      input.addEventListener('change', () => {
        
        // console.log("color change",input.value);
        localStorage.selectedColor = input.value;
        selectedColorInput = input;
        // on change tool tip image get 
        const label = document.querySelector(`label[for="${input.id}"]`);
        if (label) {
          const styleTooltipImg = label.querySelector('.style-tooltip img');
          const floatingTooltipImg = document.querySelector('.floating-style-tooltip img');
          if (styleTooltipImg && floatingTooltipImg) {
            document.querySelector('.floating-style-tooltip').style.display = "inline-block"; 
            floatingTooltipImg.src = styleTooltipImg.src;
          }
        }
        updateProductButtons(styleSelect, input); // <<< This line is key
        updateColorSwatchAvailability(styleSelect); 
        checkIfHardwareExists();
        handlePaintReadyDisabling(input.value);
        updateBanner(styleSelect);
        clrinput.classList.remove('select-color-swatch');
        updateSpecificationHeaderStatus();
        checkDesignStyleAndOpenAccordioncolor();
        // enable add to cart if color is not selected
        document.querySelectorAll('.product-item .product-item-button button').forEach(button => {
          button.removeAttribute('disabled');
        });

        // click to add ones if have color
        document.querySelectorAll(".addon_pro_details .add_product_info").forEach(addList => {
          let color = addList.querySelector(`.swatch-input__input[value="${input.value}"]`) || null;

          if (color) {
            addList.querySelector(".paint-ready-msg")?.remove();
            color.click();
          } else {
            let paintReady = addList.querySelector(`.swatch-input__input[value="Paint-Ready"]`);
            if (paintReady) {
              paintReady.click();

              // insert message after .color-with-quantity-wrapper
              let qtyWrapper = addList.querySelector(".color-with-quantity-wrapper");
              if (qtyWrapper) {
                addList.querySelector(".paint-ready-msg")?.remove();

                let msgDiv = document.createElement("div");
                msgDiv.className = "paint-ready-msg";
                msgDiv.innerHTML = `<span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path d="M256 32L20 464h472L256 32z"
                        fill="#34c759"
                        stroke="#34c759"
                        stroke-width="20"
                        stroke-linejoin="round"
                        stroke-linecap="round"/>
                  <!-- Exclamation mark -->
                  <rect x="236" y="176" width="40" height="176" fill="white" rx="8" ry="8"/>
                  <circle cx="256" cy="392" r="24" fill="white"/>
                </svg>
                </span>Color Match Unavailable. We suggest using Paint-Ready`;
                qtyWrapper.insertAdjacentElement("afterend", msgDiv);
              }
            }
          }
        });
      });
    });
      
    mainSelector.addEventListener('change', function () {
      // console.log("pro style select box change");
      // const selectedColorInput = document.querySelector('.pro-selector-content .pro-option-colors .swatch-input__input:checked');
      // hide color options if style is not selected
      const selectedColorInput = document.querySelector('.pro-selector-content .pro-option-colors .swatch-input__input');
      styleSelect = this;
        document.querySelectorAll('.pro-option-colors input[type="radio"]:checked').forEach(radio => {
          radio.checked = false;
        });
        const selectedStyle = this.value;
        const colorSection = orderForm.querySelector('.pro-selector-color');
        if (selectedStyle) {
          colorSection.style.display = 'block';
        } else {
          colorSection.style.display = 'none';
        }
      document.querySelector('.floating-style-tooltip').style.display = "none"; 
      updateProductButtons(this, selectedColorInput); // <<< This line is key
      updateColorSwatchAvailability(this); 
      checkIfHardwareExists();
      updateBanner(this,selectedColorInput);
      updateStyleHeaderStatus(selectedStyle);
      this.classList.remove('select-style');
      // disable add to cart if color is not selected
      document.querySelectorAll('.product-item .product-item-button button').forEach(button => {
        button.setAttribute('disabled', 'disabled');
      });
    });
    // END -- on change color and style set correct iamge and varinat id to product

    //  Page load: Apply step 1 - style from localStorage if exists
    let localStyle = localStorage.selectedDoorStyle;
    if(localStyle != "" && localStyle != undefined){
      document.querySelector(`.pro-style-option-single[data-value="${localStyle}"]`).click();
      // document.querySelector(".order-form-pro-selector.pro-color-selector .acco-head")?.click();
    }
    

    // START -- Secification block
    const specificationOptionElem = document.querySelector(".form-spec-style-wrap");
    const frameOptions = specificationOptionElem.querySelectorAll(".pro-option-design-style input");
    
    if (frameOptions.length) {
      const frameField = specificationOptionElem.querySelector(".form-spec-style-dimension .dimension-frame-field");
      const frameLessField = specificationOptionElem.querySelector(".form-spec-style-dimension .dimension-frameless-field");
      const framedRadio = specificationOptionElem.querySelector("#framed");
      const framelessRadio = specificationOptionElem.querySelector("#frameless");
    
      const updateFrameDisplay = () => {
        if (framedRadio.checked) {
          frameField.style.display = 'block';
          frameField.classList.add('active');
          frameLessField.style.display = 'none';
          frameLessField.classList.remove('active');
        } else if (framelessRadio.checked) {
          frameField.style.display = 'none';
          frameField.classList.remove('active');
          frameLessField.style.display = 'block';
          frameLessField.classList.add('active');
        }
      };
    
      //  Page load: Apply radio selection from localStorage if exists
      let savedSpecs = localStorage.getItem('selectedProductSpecifications');
      if (savedSpecs) {
        try {
          let parsedSpecs = JSON.parse(savedSpecs);
      
          // Design Style
          if (parsedSpecs.design_style === 'framed') {
            const framedRadio = document.querySelector('input[name="Design Style"][value="framed"]');
            if (framedRadio) {
              framedRadio.checked = true;
            }
            // Show/hide frame fields
            document.querySelector('.dimension-frame-field').style.display = 'block';
            document.querySelector('.dimension-frameless-field').style.display = 'none';
          } else if (parsedSpecs.design_style === 'frameless') {
            const framelessRadio = document.querySelector('input[name="Design Style"][value="frameless"]');
            if (framelessRadio) {
              framelessRadio.checked = true;
            }
            // Show/hide frame fields
            document.querySelector('.dimension-frame-field').style.display = 'none';
            document.querySelector('.dimension-frameless-field').style.display = 'block';
          }
      
          // Set selected specification in dropdown
          if (parsedSpecs.selected_specification) {
            const framedSelect = document.getElementById("dimension-frame");
            const framelessSelect = document.getElementById("dimension-frameless");
      
            // Try selecting it in both, only one will be visible
            [framedSelect, framelessSelect].forEach(select => {
              if (select) {
                for (let i = 0; i < select.options.length; i++) {
                  const optionVal = select.options[i].value.replace(/&quot;/g, '"');
                  if (optionVal === parsedSpecs.selected_specification) {
                    select.selectedIndex = i;
                    break;
                  }
                }
              }
            });
          }
          // Design style (framed or frameless)
          // if (parsedSpecs.design_style === 'framed') {
          //   const framedRadio = document.querySelector('input[name="design_style"][value="framed"]');
          //   if (framedRadio) {
          //     framedRadio.checked = true;
          //   }
          // } else if (parsedSpecs.design_style === 'frameless') {
          //   const framelessRadio = document.querySelector('input[name="design_style"][value="frameless"]');
          //   if (framelessRadio) {
          //     framelessRadio.checked = true;
          //   }
          // }
      
          if (parsedSpecs.design_style === 'framed') {
            const framedRadio = document.querySelector('input[name="Design Style"][value="framed"]');
            if (framedRadio) {
              framedRadio.checked = true;
            }
          } else if (parsedSpecs.design_style === 'frameless') {
            const framelessRadio = document.querySelector('input[name="Design Style"][value="frameless"]');
            // console.log("framelessRadio",framelessRadio);
            if (framelessRadio) {
              framelessRadio.checked = true;
            }
          }
          // pre_drilled_fronts 
          if (parsedSpecs.pre_drilled_fronts === 'Yes') {
            const drillYes = document.querySelector('input[name="pre_drilled_fronts"][value="Yes"]');
            if (drillYes) {
              drillYes.checked = true;
            }
          } else if (parsedSpecs.pre_drilled_fronts === 'No') {
            const drillNo = document.querySelector('input[name="pre_drilled_fronts"][value="No"]');
            if (drillNo) {
              drillNo.checked = true;
            }
          }
          // Color match paint (Yes or No)
          if (parsedSpecs.color_match_paint === "Yes") {
            const colorMatchYes = document.querySelector('input[name="color-Paint"][value="yes"]');
            if (colorMatchYes) {
              colorMatchYes.checked = true;
            }
          } else if (parsedSpecs.color_match_paint === "No") {
            const colorMatchNo = document.querySelector('input[name="color-Paint"][value="no"]');
            if (colorMatchNo) {
              colorMatchNo.checked = true;
            }
          }
        } catch (e) {
          console.error('Error parsing localStorage:', e);
        }
      }
      //  Initial UI update on page load
      updateFrameDisplay();
      const drillYesel = document.getElementById('drill-yes');
      const drillNoel = document.getElementById('drill-no');
      const drillElement = document.querySelector('.pro-option-drilled-fronts.product-form__input');
      const clrYesel = document.getElementById('color-Paint-yes');
      const clrNoel = document.getElementById('color-Paint-no');
      const clrElement = document.querySelector('.pro-option-color-Paint.product-form__input');

      //  Remove error class when user selects a Pre Drilled Fronts option
      [drillYesel, drillNoel].forEach((radio) => {
        radio.addEventListener('change', () => {
          if (drillYesel.checked || drillNoel.checked) {
            drillElement.classList.remove('select-drill');
          }
          checkDesignStyleAndOpenAccordion();
        });
      });
      
      //  Remove error class when user selects a Color Match Paint option
      [clrYesel, clrNoel].forEach((radio) => {
        radio.addEventListener('change', () => {
          if (clrYesel.checked || clrNoel.checked) {
            clrElement.classList.remove('add-color-paint');
          }
        checkDesignStyleAndOpenAccordion();
        });
      });

      // Change listener for radio buttons
      frameOptions.forEach((frameOption) => {
        frameOption.addEventListener('change', () => {
          if (frameOption.checked) {
            document.querySelector('.pro-option-design-style.product-form__input').classList.remove('select-frame');
            updateFrameDisplay();
          }
          checkDesignStyleAndOpenAccordion();
        });
      });
    
      // When framed <select> is changed, auto-check 'framed' radio
      frameField.querySelector("select").addEventListener('change', function () {
        checkDesignStyleAndOpenAccordion();
        framedRadio.checked = true;
        framedRadio.dispatchEvent(new Event('change'));
      });
    
      // When frameless <select> is changed, auto-check 'frameless' radio
      frameLessField.querySelector("select").addEventListener('change', function () {
        checkDesignStyleAndOpenAccordion();
        framelessRadio.checked = true;
        framelessRadio.dispatchEvent(new Event('change'));
      });
    }
    // END -- Secification block

    var allSelectedProducts = [];
    var selectedProductData = {};

    const addonPopupBtns = document.querySelectorAll(".pro-list-wrapper.add_on_list .product-item-button");
    const add_on_popup = document.querySelector(".custom-form-popup.add_on_info");

    if (addonPopupBtns.length) {
      addonPopupBtns.forEach((popupBtn) => {
        popupBtn.addEventListener("click", function (e) {
          e.stopPropagation();
          const product_id = popupBtn.closest(".product-item").getAttribute("data-product-id");

          if (add_on_popup) {
            add_on_popup.classList.add("active");

            const addon_product_wrappers = document.querySelectorAll(".add_product_info");
            if (addon_product_wrappers.length) {
              addon_product_wrappers.forEach((addon_product_wrapper) => {
                addon_product_wrapper.classList.add("hidden");
              });

              // show selected product info
              add_on_popup
                .querySelector(`.add_product_info[data-product-id='${product_id}']`)
                .classList.remove("hidden");
              const visibleWrapper = add_on_popup.querySelector(".add_product_info:not(.hidden)");

              if (visibleWrapper) {
                // update title and price in popup header
                const productTitle = visibleWrapper.querySelector(".product_title").textContent;
                add_on_popup.querySelector(".product-title").textContent = productTitle;

                const priceBlock = visibleWrapper.querySelector(".product-price-block");
                const formattedPrice = priceBlock.textContent;
                add_on_popup.querySelector(".info-block .product-price").textContent = formattedPrice;

                // run once when popup opens (if swatch is pre-checked)
                updateSelectedSwatch(visibleWrapper, add_on_popup);
              }
            }
          }
        });
      });

      // Close popup only on valid backdrop click
      add_on_popup.addEventListener("click", function (e) {
        if (add_on_popup.classList.contains("active")) {
          const isTriggerBtn = e.target.closest(".pro-list-wrapper.add_on_list .product-item-button");

          const warningPopup = document.querySelector(".custom-form-popup.add-on-warning");
          const isInsideWarning = warningPopup?.contains(e.target);

          // only close if clicked backdrop (not inside main content), not trigger, not warning
          if (e.target === add_on_popup && !isTriggerBtn && !isInsideWarning) {
            add_on_popup.classList.remove("active");
          }
        }
      });


      // Event delegation for choose-color button
      document.addEventListener("click", function (e) {
        if (e.target.closest(".custom-form-popup.add_on_info .choose-color")) {
          e.preventDefault();
          const visibleWrapper = add_on_popup.querySelector(".add_product_info:not(.hidden)");
          if (!visibleWrapper) return;

          const colordrpDown = visibleWrapper.querySelector(".product-color-options");
          if (!colordrpDown) return;

          updateSelectedSwatch(visibleWrapper, add_on_popup);
          colordrpDown.querySelector(".product-options").classList.toggle("active");
          visibleWrapper.querySelector(".paint-ready-msg").remove();
        }
      });

      // Event delegation for swatch inputs
      document.addEventListener("change", function (e) {
        if (e.target.matches(".custom-form-popup.add_on_info .swatch-input__input")) {
          const input = e.target;
          const visibleWrapper = add_on_popup.querySelector(".add_product_info:not(.hidden)");
          const colordrpDown = visibleWrapper.querySelector(".product-color-options");
          const colors = visibleWrapper.querySelectorAll(".swatch-input__input");

          // clear checked state
          colors.forEach((elem) => { elem.removeAttribute("checked"); });
          input.checked = true;
          input.setAttribute("checked", "");

          if (document.querySelector(".pro-color-selector input:checked")?.value !== input.value && input.value !== "Paint-Ready") {
            document.querySelector(".custom-form-popup.add-on-warning").classList.add("active");
          }

          updateSelectedSwatch(visibleWrapper, add_on_popup);
          colordrpDown.querySelector(".product-options").classList.remove("active");
        }
      });

      // Event delegation for select dropdowns
      document.addEventListener("change", function (e) {
        if (e.target.closest(".custom-form-popup.add_on_info .pro-selector-type select")) {
          const select = e.target;
          const selectedOption = select.options[select.selectedIndex];
          const variantId = selectedOption.getAttribute("data-variant-id");

          const productDetails = select.closest(".product_details");
          if (productDetails) {
            const button = productDetails.querySelector(".product-item-button button");
            if (button) {
              button.setAttribute("data-variant-id", variantId);
            }
          }
        }
      });

      // Event delegation for Add to Cart button
      document.addEventListener("click", function (e) {
        if (e.target.closest(".custom-form-popup.add_on_info .product-item-button .add_atc_btn")) {
          const addButton = e.target.closest(".add_atc_btn");
          const visibleWrapper = add_on_popup.querySelector(".add_product_info:not(.hidden)");

          if (!visibleWrapper) return;

          // check swatch selection
          const colors = visibleWrapper.querySelectorAll(".swatch-input__input");
          if (colors.length) {
            var selectedColorInput = visibleWrapper.querySelector(".swatch-input__input:checked");
            if (!selectedColorInput) {
              alert("Please select a color before adding this product.");
              return;
            }
          }

          var variantId = visibleWrapper.querySelector(".product-item-button").getAttribute("data-variant-id");
          var title = visibleWrapper.querySelector(".product_title")?.textContent.trim();
          var image = visibleWrapper.querySelector(".product_title")?.getAttribute("data-image");
          var price = visibleWrapper.querySelector(".product-price-block")?.getAttribute("data-price");

          var selectedColorInput = visibleWrapper.querySelector(".swatch-input__input:checked");
          var selectedColor = selectedColorInput?.value;

          var select = visibleWrapper.querySelector(".pro-selector-type select");
          var selectedValue = select?.value;

          const quantity = visibleWrapper.querySelector(".quantity__input").value;
          let timestamp = Date.now();

          let selectedProductData = {
            mainProduct: {
              variant_id: variantId,
              title: title,
              image: image,
              color: selectedColor,
              style: selectedValue,
              quantity: quantity,
              price: price,
              pdp: "_add-on",
              properties: { _timestamp: timestamp }
            },
            dimensions: [],
            hardwareProduct: null
          };

          allSelectedProducts.push(selectedProductData);
          localStorage.setItem("selectedProductData", JSON.stringify(allSelectedProducts));
          renderSelectionItems(allSelectedProducts);

          add_on_popup.classList.remove("active");
        }
      });
    }
    // helper function to update selected swatch image
    function updateSelectedSwatch(visibleWrapper, add_on_popup) {
      const checkedInput = visibleWrapper.querySelector(".swatch-input__input:checked");
      if (checkedInput) {
        let label;
        if (checkedInput.id) {
          label = visibleWrapper.querySelector(`label[for="${checkedInput.id}"]`);
        } else {
          label = checkedInput.closest("label");
        }
        const value = checkedInput.value;
        const variant_id = checkedInput.getAttribute("data-variant-id");
        
        visibleWrapper.querySelector(".product-item-button").setAttribute("data-variant-id",variant_id);

        if (label) {
          const spanWithImage = label.querySelector("span");
          if (spanWithImage) {
            const imageURL = spanWithImage.getAttribute("data-img-url");
            const swatchEl = visibleWrapper.querySelector(".selected-swatch .swatch");
            if (swatchEl) {
              swatchEl.style.backgroundImage = `url("${imageURL}")`;
            }
            visibleWrapper.querySelector(".selected-swatch .swatch-text").textContent = value;
          }
        }
      }
    }

    // END -- Add on product section 

    var productBtns = document.querySelectorAll(".selection-list .product-item .product-item-button button");
    var dimensionPopup =  document.querySelector(".custom-form-popup.dimension");
  
    function alreadyInCart(existingProduct){
      var dimensionQuantity = existingProduct.mainProduct.quantity;
      let dimensionData = dimensionPopup.querySelector('.dimension-details-list');
      var fieldsWrapper = dimensionPopup.querySelector(".dimension-form-fields");
      // console.log("fieldsWrapper",fieldsWrapper);
      var inputWidth = fieldsWrapper.querySelector('#width');
      const width = inputWidth.value.trim();
      var inputHeight = fieldsWrapper.querySelector('#height');
      const height = inputHeight.value.trim();
      var inputQuantity = fieldsWrapper.querySelector('#quantity');
      const quantityValue = inputQuantity.value.trim();
      var inputNote = fieldsWrapper.querySelector('#notes');
      const notes = inputNote.value.trim() || 'No Comments';
     
      dimensionData.innerHTML = '';
      existingProduct.dimensions.forEach((dimension, index) => {
        const li = document.createElement('li');
        li.className = 'dimension-details-item';
        li.innerHTML = `
          <div class="dimension-detials-item-wrap">
            <p>
              <span><span>Qty:</span> <span class="qty-val item-quantity">${dimension.quantity}</span></span>
              <span><span>Width</span>: <span class="item-width">${dimension.width}</span></span>
              <span><span>Height</span>: <span class="item-height">${dimension.height}</span></span>
              <span><span>Notes</span>: <span class="item-notes">${dimension.notes}</span></span>
            </p>
             <span class="btn-item-remove" style="cursor:pointer;">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.1667 14.655C4.01033 14.8114 3.92249 15.0235 3.92249 15.2446C3.92249 15.4658 4.01033 15.6778 4.1667 15.8342C4.32307 15.9906 4.53515 16.0784 4.75628 16.0784C4.97742 16.0784 5.1895 15.9906 5.34587 15.8342L10 11.1784L14.655 15.8334C14.8122 15.9852 15.0227 16.0692 15.2412 16.0673C15.4597 16.0654 15.6687 15.9777 15.8232 15.8232C15.9777 15.6687 16.0654 15.4597 16.0673 15.2412C16.0692 15.0227 15.9852 14.8122 15.8334 14.655L11.1784 10L15.8334 5.34503C15.9896 5.18867 16.0774 4.97663 16.0773 4.75557C16.0772 4.53451 15.9893 4.32254 15.8329 4.16628C15.6766 4.01003 15.4645 3.92229 15.2435 3.92236C15.0224 3.92244 14.8105 4.01033 14.6542 4.1667L10 8.8217L5.34503 4.1667C5.18786 4.0149 4.97736 3.93091 4.75886 3.9328C4.54037 3.9347 4.33136 4.02234 4.17685 4.17685C4.02234 4.33136 3.9347 4.54037 3.9328 4.75886C3.93091 4.97736 4.0149 5.18786 4.1667 5.34503L8.8217 10L4.1667 14.655Z" fill="#0E416B"></path>
              </svg>
            </span>
            <span class="edit_dimensions">Edit</span>
          </div>
        `;
        
        dimensionData.appendChild(li);
        // dimensionQuantity += Number(dimension.quantity);
        // console.log("Li elemnt",li);
        li.querySelector('.btn-item-remove').addEventListener('click', () => {
          const removedQty = parseInt(li.querySelector('.qty-val').textContent, 10);
          dimensionQuantity -= removedQty;
          dimensionPopup.querySelector(".dimesion-total-qty").textContent = dimensionQuantity;
          event.target.closest("li").remove();
        });
        li.querySelector('.edit_dimensions').addEventListener('click', () => {
          const editItem = li; // The current dimension item you're editing
        
          const itemWidth = editItem.querySelector('.item-width')?.textContent.trim();
          const itemHeight = editItem.querySelector('.item-height')?.textContent.trim();
          const itemQuantity = parseInt(editItem.querySelector('.item-quantity')?.textContent.trim());
          const itemNotes = editItem.querySelector('.item-notes')?.textContent.trim();

          dimensionQuantity -= itemQuantity;
           dimensionPopup.querySelector(".dimesion-total-qty").textContent = dimensionQuantity;
        
          inputWidth.value = itemWidth || '';
          inputHeight.value = itemHeight || '';
          inputQuantity.value = itemQuantity || '';
          inputNote.value = (itemNotes === 'No Comments') ? '' : itemNotes;
          editItem.remove();
        });
      });
      dimensionPopup.querySelector(".dimesion-total-qty").textContent = dimensionQuantity;
      existingProduct.mainProduct.quantity = dimensionQuantity;
    }
  
    if(productBtns.length){
      productBtns.forEach((btn)=>{
        btn.addEventListener('click',function(){
          const productStyleSelect = document.getElementById('pro-style');
          const clrinput = document.querySelector('.pro-option-colors.product-form__input');
          // Validate style selection
          if (productStyleSelect.value === "") {
            productStyleSelect.classList.add('select-style'); // Add visual cue
            alert('Step 1: Please select a product style to continue.');
            return; // Stop further execution
          }
          // Validate color selection
          const anyChecked = document.querySelector('.pro-option-colors input[type="radio"]:checked');
          if (!anyChecked) {
            clrinput.classList.add('select-color-swatch'); // Add visual cue
            alert('Step 1: Please select a product color to continue.');
            return; // Stop further execution
          }
          const productItem = btn.closest(".product-item");
          var pdpTitle = productItem.querySelector(".product_details .product_title").textContent;
          dimensionPopup.querySelector(".product-title").textContent = pdpTitle;
          dimensionPopup.classList.add("active");
          document.body.classList.add("popup-active");
          const choose_HardwareBtn = dimensionPopup.querySelector(".dimension-form-action.choose_hardware");
          const continueBtn = dimensionPopup.querySelector(".continue-action.confirm-btn");

          if(productItem.classList.contains('not-hardware')){
            choose_HardwareBtn.classList.add('hidden');
            continueBtn.classList.remove('hidden');
          }else{
          choose_HardwareBtn.classList.remove('hidden');
            continueBtn.classList.add('hidden');
          }

          var dimensionData = dimensionPopup.querySelector('.dimension-details-list');
          dimensionData.innerHTML = '';       
          
          // create an object for product details
          const variantId = btn.getAttribute("data-variant-id");
          const selectedStyle = document.querySelector('.pro-selector-content #pro-style')?.value;
          const selectedColor = document.querySelector('.pro-selector-content .swatch-input__input:checked')?.value;
          const variants = JSON.parse(productItem.getAttribute('data-variants') || "[]");
          const matchedVariant = variants.find(v => v.id == variantId);
          // console.log("matchedVariant",matchedVariant);
          const price = matchedVariant ? matchedVariant.price : null;
          const productId = productItem.getAttribute("data-product-id");
          const image = productItem.querySelector(".product-image img").src;
          const oversize_product_id = matchedVariant.metafields.oversized_product;
          dimensionPopup.querySelector(".dimension-form-main").setAttribute("data-variant-id",variantId);
          orderForm.querySelector(".hardware-form-main").setAttribute("main-variant-id",variantId);
          
          var form_body = dimensionPopup.querySelector(".form-body-wrap");
          var min_width = '';
          var max_width = '';
          var min_height = '';
          var max_height = '';
          
          if(matchedVariant){
            min_width = matchedVariant.metafields.minimum_width;
            max_width = matchedVariant.metafields.maximum_width;
            min_height = matchedVariant.metafields.minimum_height;
            max_height = matchedVariant.metafields.maximum_height;

            form_body.setAttribute("min_width",min_width);
            form_body.setAttribute("max_width",max_width);
            form_body.setAttribute("min_height",min_height);
            form_body.setAttribute("max_height",max_height);
          }

          // console.log("product.mainProduct",product.mainProduct);

          console.log("allSelectedProducts",allSelectedProducts);
          var existingProduct = allSelectedProducts.find(item => 
            item?.mainProduct && item.mainProduct.variant_id === variantId
          );

          
          // check if product already available in cart
          if(existingProduct){
            alreadyInCart(existingProduct);
          }else{
            dimensionPopup.querySelector(".dimesion-total-qty").textContent = 0;
            selectedProductData = {
              mainProduct: {
                product_id: productId,
                variant_id: variantId,
                oversize_product:null,
                title: pdpTitle,
                type : "main",
                image: image,
                color: selectedColor,
                style: selectedStyle,
                quantity: null,
                price: price,
                min_width: min_width,
                min_height: min_height,
                max_width: max_width,
                max_height: max_height,
                properties: {pdptype:'add-on'},
              },
              dimensions: null,
              hardwareProduct: null,
              all_variants : variants
            };
          } 
          // console.log("oversized_product",oversize_product_id);
          //  const inputHeight = dimensionPopup.querySelector('#height');
          // const heightVal = inputHeight?.value?.trim();
          // const parsedHeight = heightVal ? parseFractionalValue(heightVal) : null;
          if (oversize_product_id) {
            selectedProductData.mainProduct.oversize_product = oversize_product_id;
          }
          
          // console.log("selectedProductData",selectedProductData);

          setTimeout(() => {
            document.querySelectorAll(`.info-tooltip[data-tooltip-info="dimension"] item-type`).forEach(itemType => {
              itemType.innerHTML = btn.closest(".product-item").querySelector('.product_title') ? btn.closest(".product-item").querySelector('.product_title').innerHTML : "";
            });
            // console.log("title",btn.closest(".product-item").querySelector('.product_title'));
            document.querySelectorAll(".pro-qty-selector-alert .item-type").forEach(itemT => {
              itemT.innerHTML = btn.closest(".product-item").querySelector('.product_title') ? btn.closest(".product-item").querySelector('.product_title').innerHTML : "";
            });
          },2000);
        });
      });
    }

    var totalQuantity = 0; // Tracks total quantity across all added items

    function parseFractionalValue(input) {
      const fractions = {
        "1/16": 0.0625, "1/8": 0.125, "3/16": 0.1875, "1/4": 0.25,
        "5/16": 0.3125, "3/8": 0.375, "7/16": 0.4375, "1/2": 0.5,
        "9/16": 0.5625, "5/8": 0.625, "11/16": 0.6875, "3/4": 0.75,
        "13/16": 0.8125, "7/8": 0.875, "15/16": 0.9375
      };
    
      input = input.trim();
      if (/^\d+(\.\d+)?$/.test(input)) return parseFloat(input);
    
      const parts = input.split(" ");
      if (parts.length === 2 && /^\d+$/.test(parts[0]) && fractions[parts[1]]) {
        return parseInt(parts[0], 10) + fractions[parts[1]];
      }
    
      if (parts.length === 1 && fractions[parts[0]]) return fractions[parts[0]];
      return null;
    }
    
    orderForm.querySelector('.dimension-form').addEventListener('submit', function(e) {
      e.preventDefault();
    
      totalQuantity = Number(dimensionPopup.querySelector(".dimesion-total-qty").textContent) || 0;
      const fieldsWrapper = this.querySelector(".dimension-form-fields");
      const inputWidth = fieldsWrapper.querySelector('#width');
      const width = inputWidth.value.trim();
      const inputHeight = fieldsWrapper.querySelector('#height');
      const height = inputHeight.value.trim();
      const inputQuantity = fieldsWrapper.querySelector('#quantity');
      const quantityValue = inputQuantity.value.trim();
      const inputNote = fieldsWrapper.querySelector('#notes');
      const notes = inputNote.value.trim() || 'No Comments';
    
      if (!width || !height || !quantityValue) {
        alert("Width, Height, and Quantity are required.");
        return;
      }
    
      const widthNum = parseFractionalValue(width);
      if (widthNum === null) {
        alert("Invalid width format. Use format like '23 1/4' or '1/2'.");
        return;
      }
    
      const heightNum = parseFractionalValue(height);
      if (heightNum === null) {
        alert("Invalid height format. Use format like '15 3/8' or '3/4'.");
        return;
      }
    
      const formBodyWrap = dimensionPopup.querySelector('.form-body-wrap');
      const minWidth = parseFloat(formBodyWrap.getAttribute('min_width'));
      const maxWidth = parseFloat(formBodyWrap.getAttribute('max_width'));
      const minHeight = parseFloat(formBodyWrap.getAttribute('min_height'));
      const maxHeight = parseFloat(formBodyWrap.getAttribute('max_height'));
      // const height_limit = '63';

      if (!isNaN(minWidth) && widthNum < minWidth) {
        alert(`Width must be at least ${minWidth}.`);
        return;
      }
      const oversized_limit = 42; 
      if (!isNaN(maxWidth) && widthNum > maxWidth) {
        const confirmWidth = confirm(`The width must be no larger than ${maxWidth} `);
         return;
      }
      
      if (!isNaN(minHeight) && heightNum < minHeight) {
        alert(`Height must be at least ${minHeight}.`);
        return;
      }
    
      // const height_limit = 63;
       // new lower limit for oversized
        
        if (heightNum > maxHeight) {
          alert(`Height cannot exceed ${maxHeight}.`);
          return;
        }

        if (heightNum > oversized_limit ) {
          const confirmHeight = confirm(`Height exceeds ${oversized_limit} and will be considered an oversized product. Do you want to proceed?`);
          if (!confirmHeight) return;
        }

      const quantity = parseInt(quantityValue, 10);
      if (isNaN(quantity) || quantity <= 0) {
        alert("Quantity must be a valid number greater than 0.");
        return;
      }
    
      const list = document.querySelector('.dimension-details-list');
      const li = document.createElement('li');
      li.className = 'dimension-details-item';
      li.innerHTML = `
        <div class="dimension-detials-item-wrap">
          <p>
            <span><span>Qty:</span> <span class="qty-val item-quantity">${quantity}</span></span>
            <span><span>Width</span>: <span class="item-width">${width}</span></span>
            <span><span>Height</span>: <span class="item-height">${height}</span></span>
            <span><span>Notes</span>: <span class="item-notes">${notes}</span></span>
          </p>
          <span class="btn-item-remove" style="cursor:pointer;">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M4.1667 14.655C4.01033 14.8114 3.92249 15.0235 3.92249 15.2446C3.92249 15.4658 4.01033 15.6778 4.1667 15.8342C4.32307 15.9906 4.53515 16.0784 4.75628 16.0784C4.97742 16.0784 5.1895 15.9906 5.34587 15.8342L10 11.1784L14.655 15.8334C14.8122 15.9852 15.0227 16.0692 15.2412 16.0673C15.4597 16.0654 15.6687 15.9777 15.8232 15.8232C15.9777 15.6687 16.0654 15.4597 16.0673 15.2412C16.0692 15.0227 15.9852 14.8122 15.8334 14.655L11.1784 10L15.8334 5.34503C15.9896 5.18867 16.0774 4.97663 16.0773 4.75557C16.0772 4.53451 15.9893 4.32254 15.8329 4.16628C15.6766 4.01003 15.4645 3.92229 15.2435 3.92236C15.0224 3.92244 14.8105 4.01033 14.6542 4.1667L10 8.8217L5.34503 4.1667C5.18786 4.0149 4.97736 3.93091 4.75886 3.9328C4.54037 3.9347 4.33136 4.02234 4.17685 4.17685C4.02234 4.33136 3.9347 4.54037 3.9328 4.75886C3.93091 4.97736 4.0149 5.18786 4.1667 5.34503L8.8217 10L4.1667 14.655Z" fill="#0E416B"></path>
            </svg>
          </span>
          <span class="edit_dimensions">Edit</span>
        </div>
      `;
    
      list.appendChild(li);
    
      totalQuantity += quantity;
      document.querySelector('.dimension-form-main .form-header .dimesion-total-qty').textContent = totalQuantity;
    
      inputWidth.value = '';
      inputHeight.value = '';
      inputQuantity.value = '';
      inputNote.value = '';
    
      li.querySelector('.btn-item-remove').addEventListener('click', (event) => {
        const removedQty = parseInt(li.querySelector('.qty-val').textContent, 10);
        totalQuantity -= removedQty;
        document.querySelector('.dimension-form-main .form-header .dimesion-total-qty').textContent = totalQuantity;
        event.target.closest("li").remove();
      });
    
      li.querySelector('.edit_dimensions').addEventListener('click', () => {
        const editItem = li;
        const itemWidth = editItem.querySelector('.item-width')?.textContent.trim();
        const itemHeight = editItem.querySelector('.item-height')?.textContent.trim();
        const itemQuantity = parseInt(editItem.querySelector('.item-quantity')?.textContent.trim());
        const itemNotes = editItem.querySelector('.item-notes')?.textContent.trim();

        totalQuantity -= itemQuantity;
         document.querySelector('.dimension-form-main .form-header .dimesion-total-qty').textContent = totalQuantity;
    
        inputWidth.value = itemWidth || '';
        inputHeight.value = itemHeight || '';
        inputQuantity.value = itemQuantity || '';
        inputNote.value = (itemNotes === 'No Comments') ? '' : itemNotes;
        editItem.remove();
      });
    });

    var hardwarePopup = document.querySelector(".custom-form-popup.hardware");
    //dimension form submit code
    orderForm.querySelector(".dimension-form .dimension-form-action.choose_hardware").addEventListener('click', function(e) {
      e.preventDefault();
      // console.log("choose Hardware button click", allSelectedProducts);

      const variantId = this.closest(".dimension-form-main").getAttribute("data-variant-id");
      console.log("allSelectedProducts",allSelectedProducts);
      const index = allSelectedProducts.findIndex(item => {
        return item && item.mainProduct && item.mainProduct.variant_id === variantId;
      });

      const totalQtyEl = dimensionPopup.querySelector(".dimesion-total-qty");
      totalQuantity = Number(totalQtyEl.textContent) || 0;

      let existingProduct = null;

      if (index !== -1) {
        existingProduct = allSelectedProducts[index];
        existingProduct.dimensions = [];
        allSelectedProducts[index] = existingProduct; // enforce update (not always necessary, but for clarity)
      }
      if (existingProduct) {
        existingProduct.dimensions = [];
      } else{
        selectedProductData.dimensions = [];
      }
      const listItems = document.querySelectorAll('.dimension-details-item');
      if (listItems.length === 0) {
        alert("Please add at least one item to continue.");
        return; 
      }
  
      listItems.forEach(item => {
        const width = item.querySelector('.item-width')?.textContent.trim();
        const height = item.querySelector('.item-height')?.textContent.trim();
        const quantity = item.querySelector('.item-quantity')?.textContent.trim();
        const notes = item.querySelector('.item-notes')?.textContent.trim();
        const dimensionData = { width, height, quantity, notes };

        if (existingProduct) {
          existingProduct.dimensions.push(dimensionData);
        } else {
          selectedProductData.dimensions.push(dimensionData);
        }
      });

      if (totalQuantity === 0) {
        totalQuantity = 1;
      }
    
      if (existingProduct) {
        existingProduct.mainProduct.quantity = totalQuantity;
      } else if (selectedProductData.mainProduct) {
        selectedProductData.mainProduct.quantity = totalQuantity;
        // console.log(totalQuantity, "totalQuantity")
      }
      // hardwareForm.querySelector(".quantity__input").value = totalQuantity; 
      // hardwareForm.querySelector(".quantity__input").max = totalQuantity;
     const inputs = hardwareForm.querySelectorAll(".quantity__input");

      // Ensure totalQuantity is a number and at least the minimum allowed
   
      inputs.forEach((input)=>{
        const quantity = Math.max(Number(totalQuantity), Number(input.min) || 1);
        // Set the max and value safely
        input.max = quantity;
        input.valueAsNumber = quantity;
        input.closest("quantity-input").querySelector(`[name="plus"]`).classList.add("disabled");
        
      });
      dimensionPopup.classList.remove("active");
      hardwarePopup.classList.add("active");
      document.body.classList.add("popup-active");
    });

    function continueWithouthardware(){
       // e.preventDefault();
      // console.log("Continue", allSelectedProducts);
    
      const variantId = orderForm.querySelector(".dimension-form-main").getAttribute("data-variant-id");
      console.log("allSelectedProducts",allSelectedProducts);
      const index = allSelectedProducts.findIndex(item => {
        return item && item.mainProduct && item.mainProduct.variant_id === variantId;
      });
      const totalQtyEl = dimensionPopup.querySelector(".dimesion-total-qty");
      totalQuantity = Number(totalQtyEl.textContent) || 0;
    
      let existingProduct = null;
    
      if (index !== -1) {
        existingProduct = allSelectedProducts[index];
        existingProduct.dimensions = [];
        allSelectedProducts[index] = existingProduct; // enforce update (not always necessary, but for clarity)
      }
       if (existingProduct) {
          existingProduct.dimensions = [];
        }else{
          selectedProductData.dimensions = [];
        }
    
      const listItems = document.querySelectorAll('.dimension-details-item');
      listItems.forEach(item => {
        const width = item.querySelector('.item-width')?.textContent.trim();
        const height = item.querySelector('.item-height')?.textContent.trim();
        const quantity = item.querySelector('.item-quantity')?.textContent.trim();
        const notes = item.querySelector('.item-notes')?.textContent.trim();
        const dimensionData = { width, height, quantity, notes };
    
        if (existingProduct) {
          existingProduct.dimensions.push(dimensionData);
        } else {
          selectedProductData.dimensions.push(dimensionData);
        }
      });
    
      if (totalQuantity === 0) {
        totalQuantity = 1;
      }
    
      if (existingProduct) {
        existingProduct.mainProduct.quantity = totalQuantity;
      } else {
        selectedProductData.mainProduct.quantity = totalQuantity;
        allSelectedProducts.push(selectedProductData);
      }
     
    
      renderSelectionItems(allSelectedProducts);
      localStorage.setItem("selectedProductData", JSON.stringify(allSelectedProducts));
      dimensionPopup.classList.remove("active");
    }

    // cart_button.addEventListener('click', handleAddToCartClick);
    orderForm.querySelector(".dimension-form .dimension-form-action.continue-action").addEventListener('click',continueWithouthardware);
    orderForm.querySelector(".hardware-form-main button.action-button-secondary").addEventListener('click',continueWithouthardware);
                                                                                                       
    document.addEventListener("click", function (event) {
      const clickedInsideDimension = event.target.closest(".dimension-form-main");
      const clickedInsideHardware = event.target.closest(".hardware-form-main") && !(event.target.closest(".hardware-form-main .action-button-secondary"))  ||  event.target.closest(".order-form-main") || event.target.closest(".dimension-form-action.choose_hardware");
      const clickedOnProductBtn = [...productBtns].some(btn => btn.contains(event.target));
      const cart_edit_btns = document.querySelectorAll(".form-selection-items .edit-btn");
      const clickedOnEditBtn =  [...cart_edit_btns].some(btn => btn.contains(event.target));

      // console.log("event.target",event.target);
      
      // Handle dimension popup
      if (!clickedInsideDimension && !clickedOnProductBtn && !(event.target.closest(".btn-item-remove")) && !clickedOnEditBtn && !(event.target.closest(".edit_dimensions")) && !event.target.classList.contains("tooltip-popup")) {
        dimensionPopup.classList.remove("active");
      }
      if (!clickedInsideHardware && !(event.target.closest(".btn-item-remove"))) {
        hardwarePopup.classList.remove("active");
      } 
      if ( !dimensionPopup.classList.contains("active") && !hardwarePopup.classList.contains("active") ) {
        document.body.classList.remove("popup-active");
      }
    });
   
    // Hardware Popup
    const hardwareForm = orderForm.querySelector('.hardware-form');
    const hardwareItems = hardwareForm.querySelectorAll(".hardware-items .form-pro-list-item");
    const confirmBtn = hardwareForm.querySelector("button.action-button");
    const withoutHardwareBtn = hardwareForm.querySelector("button.action-button-secondary");

    function updateVariantId(optionContainer,sizeSelect,colorInput) {
      // const selectedColor = colorInput ? colorInput.value : null;
      const selectedColor = document.querySelector(".form-product-options:not(.hidden) .swatch-input__input:checked")?.value || "";
      const selectedSize = sizeSelect ? sizeSelect.value : null;
       // console.log("selectedColor",selectedColor);
       // console.log("selectedSize",selectedSize);
      
      // Get product variants from data attribute
      const variantsJSON = optionContainer.getAttribute('data-variants');
      if (!variantsJSON) return;
      const variants = JSON.parse(variantsJSON);
      
      let matchedVariant = variants.find(variant => {
        return (
          variant.option1 === selectedColor && 
          variant.option2 === selectedSize
        );
      });

      if(sizeSelect.querySelector(`option[value='${selectedSize}']`).hasAttribute("data-group-product")){
        let variantsJSON1 = document.querySelector(`.form-product-options[data-product-id="${sizeSelect.selectedOptions[0].dataset.productId}"]`).getAttribute('data-variants');
        if (!variantsJSON) return;
        let variants1 = JSON.parse(variantsJSON1);
        
        matchedVariant = variants1.find(variant => {
          return (
            variant.option1 === selectedColor && 
            variant.option2 === selectedSize
          );
        });
        // console.log("matchedVariant inside",matchedVariant);
      }
      if (matchedVariant) {
        // For example, update a confirm button with the selected variant ID
        confirmBtn.setAttribute('data-variant-id', matchedVariant.id);
        hardwareForm.querySelector(".form-pro-list-item.active img").src = matchedVariant.featured_image ? matchedVariant.featured_image.src : document.querySelector(".hardware-option-single.active img").src;
      }
      else {
        if(sizeSelect.selectedOptions[0].hasAttribute("data-group-product")){
          // console.log("but grp product");
          confirmBtn.setAttribute('data-variant-id', sizeSelect.selectedOptions[0].dataset.variantId);
          hardwareForm.querySelector(".form-pro-list-item.active img").src = document.querySelector(".hardware-option-single.active img").src;
        }
      }
    }

    // hardware form valoidation 
    function checkColorAndSizeSelection(optionContainer) {
      // console.log("checkColorAndSizeSelection");
      const selectedColor = optionContainer.querySelector(".pro-option-colors input:checked")?.value?.trim();
    
      const errorMsg = document.querySelector(".hardware-error-msg");
      const confirmBtn = document.querySelector(".hardware-action-button");
    
      // Check all .hardware-option-size-list — each must have at least one .active item
      const allSizeLists = optionContainer.querySelectorAll(".hardware-option-size-list");
      let allSizesSelected = true;
    
      allSizeLists.forEach(sizeList => {
        const hasActive = sizeList.querySelector(".hardware-option-size-item.active");
        if (!hasActive) {
          allSizesSelected = false;
        }
      });
    
      if (selectedColor && allSizesSelected) {
        confirmBtn.removeAttribute("disabled");
        errorMsg.style.display = "none";
      } else {
        confirmBtn.setAttribute("disabled", true);
        errorMsg.style.display = "block";
      }
    }

    function setInitialOptions(optionContainer) {
      // console.log("setInitialOptions>>>>>",optionContainer);
      const firstRadio = optionContainer.querySelector("input[type='radio']");
      if (firstRadio) {
        // firstRadio.checked = true;
        firstRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    
      const firstSelect = optionContainer.querySelector("select");
      if (firstSelect) {
        // firstSelect.selectedIndex = 0;
        firstSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
      updateVariantId(optionContainer,firstSelect,firstRadio);
      
      const mainSelector = optionContainer.querySelector(".pro-option-style select");
      const colorSwatches = hardwareForm.querySelectorAll('.swatch-input__input');
    
      colorSwatches.forEach((input) => {
        input.addEventListener('click', () => {
          // console.log("color change");
          // Uncheck all radios: DOM property & attribute both
          colorSwatches.forEach((color) => {
            color.checked = false;
            color.removeAttribute("checked");
          });
              
          // Set current as checked: DOM property & attribute both
          input.checked = true;
          input.setAttribute("checked", "");
          // input.checked = true;
          // input.setAttribute("checked","");
          updateVariantId(optionContainer,firstSelect,input);
          updateBanner(styleSelect);
          checkColorAndSizeSelection(optionContainer);
          document.querySelectorAll(".form-product-options:not(.hidden) [data-option-size-item]").forEach((item,index) => {
            // document.querySelector(`.form-product-options[data-product-id="${item.dataset.productId}"]`).getAttribute('data-variants');
            let variantsJSON1 = document.querySelector(`.form-product-options[data-product-id="${item.dataset.productId}"]`).getAttribute('data-variants');
            if (!variantsJSON1) return;
            let variants1 = JSON.parse(variantsJSON1);
            let iSize = item.dataset.value;
            let color = item.closest(".form-product-options").querySelector(".pro-option-colors input:checked").value;
            let matchedVariant1 = variants1.find(variant => {
              return (
                variant.option1 === color && 
                variant.option2 === iSize
              );
            });
            item.querySelector("img").src = matchedVariant1.featured_image.src;
            item.dataset.variantId = matchedVariant1.id;
            // item.closest(".form-product-options").querySelectorAll(`select option`)[index].value = matchedVariant1.id;
            item.closest(".form-product-options").querySelectorAll(`select option`)[index].dataset.variantId = matchedVariant1.id;
          });
        });
      });
        
      mainSelector.addEventListener('change', function () {
        // const selectedColorInput = document.querySelector('.pro-selector-content pro-option-colors .swatch-input__input:checked');
        updateVariantId(optionContainer,this,firstRadio);
        // checkIfHardwareExists();
        updateBanner(this);
        checkColorAndSizeSelection(optionContainer);
      });
    }
  
    if (hardwareItems.length) {
      hardwareItems.forEach((hardwareProduct) => {
        hardwareProduct.addEventListener('click', function () {
          console.log("hardwareProduct",hardwareProduct);
          hardwareItems.forEach((item) => item.classList.remove('active'));
          this.classList.add('active');

          const productId = hardwareProduct.getAttribute("data-product-id");
          if(productId){
            confirmBtn.classList.remove('hidden');
            withoutHardwareBtn.classList.add('hidden');
          } else {
            confirmBtn.classList.add('hidden');
            withoutHardwareBtn.classList.remove('hidden');
          }

          hardwareForm.querySelectorAll(".form-product-options").forEach((optionContainer) => {
            optionContainer.classList.add('hidden');
          });

          const selectedOptionsContainer = hardwareForm.querySelector(".form-product-options[data-product-id='" + productId + "']");
          if(selectedOptionsContainer){
            selectedOptionsContainer.classList.remove('hidden');
            setInitialOptions(selectedOptionsContainer);
          } 
        });
      });

      let proListArr = document.querySelectorAll(".hardware-options-wrap .hardware-option-single");
      proListArr.forEach(item => {
        item.addEventListener("click",function(e){
          e.preventDefault();
          document.querySelector(".hardware-options-wrap .hardware-option-single.active")?.classList.remove("active");
          this.classList.add("active");
          document.querySelectorAll(".form-product-options").forEach(optionContainer => {
            optionContainer.classList.add("hidden");
            optionContainer.querySelectorAll('input[type="radio"]').forEach(radio => {
              radio.checked = false;
            });
          });

          const productId = this.getAttribute("data-product-id");
          if(productId){
            confirmBtn.classList.remove('hidden');
            withoutHardwareBtn.classList.add('hidden');
          
            // validation error msg if style is not selected
            const hardwareerrorMsg = document.querySelector(".hardware-error-msg");
            hardwareerrorMsg.textContent = "Please select color and size";
            document.querySelector(`.form-product-options:not(.hidden)`)?.classList.add("hidden");
            document.querySelector(`.form-product-options[data-product-id="${this.dataset.productId}"]`).classList.remove("hidden");
        
            hardwareForm.querySelectorAll(".form-product-options").forEach((optionContainer) => {
              optionContainer.classList.add('hidden');
            });
        
            const selectedOptionsContainer = hardwareForm.querySelector(".form-product-options[data-product-id='" + productId + "']");
            if(selectedOptionsContainer){
              selectedOptionsContainer.classList.remove('hidden');
              setInitialOptions(selectedOptionsContainer);
            }
            checkColorAndSizeSelection(selectedOptionsContainer);

          }else {
            confirmBtn.classList.add('hidden');
            withoutHardwareBtn.classList.remove('hidden');
          }
        });
      });
      
    }
  
    const initialVisibleOption = hardwareForm.querySelector(".form-product-options:not(.hidden)");
    if (initialVisibleOption) {
      setInitialOptions(initialVisibleOption);
    }

    // Hardware popup 
    var items_wrapper = orderForm.querySelector('.form-selection-items'); 
    var cart_button = orderForm.querySelector(".order-form-selection .form-selection-footer");
    var emptySelection = orderForm.querySelector(".selection-empty");
    function formatPrice(price) {
      return `$${(price / 100).toFixed(2)}/ea`;
    }
    const closeSVG = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.29303 5.29299C5.48056 5.10552 5.73487 5.0002 6.00003 5.0002C6.26519 5.0002 6.5195 5.10552 6.70703 5.29299L12 10.586L17.293 5.29299C17.3853 5.19748 17.4956 5.1213 17.6176 5.06889C17.7396 5.01648 17.8709 4.98889 18.0036 4.98774C18.1364 4.98659 18.2681 5.01189 18.391 5.06217C18.5139 5.11245 18.6255 5.1867 18.7194 5.28059C18.8133 5.37449 18.8876 5.48614 18.9379 5.60904C18.9881 5.73193 19.0134 5.86361 19.0123 5.99639C19.0111 6.12917 18.9835 6.26039 18.9311 6.38239C18.8787 6.5044 18.8025 6.61474 18.707 6.70699L13.414 12L18.707 17.293C18.8892 17.4816 18.99 17.7342 18.9877 17.9964C18.9854 18.2586 18.8803 18.5094 18.6948 18.6948C18.5094 18.8802 18.2586 18.9854 17.9964 18.9877C17.7342 18.9899 17.4816 18.8891 17.293 18.707L12 13.414L6.70703 18.707C6.51843 18.8891 6.26583 18.9899 6.00363 18.9877C5.74143 18.9854 5.49062 18.8802 5.30521 18.6948C5.1198 18.5094 5.01463 18.2586 5.01236 17.9964C5.01008 17.7342 5.11087 17.4816 5.29303 17.293L10.586 12L5.29303 6.70699C5.10556 6.51946 5.00024 6.26515 5.00024 5.99999C5.00024 5.73483 5.10556 5.48052 5.29303 5.29299Z" fill="#0E416B"/>
    </svg>`;
      
    function renderSelectionItems(allItems) {
      // console.log("All items",allItems);
      // console.log("Render Selection items function calledd...");
      let outputHTML = "";
      allItems.forEach(data => {
        if(data){
          if(!data.mainProduct) return; 
          
          const style = data.mainProduct.style;
          const productVariants = data.all_variants || []; 

          const matchingStyleVariants = productVariants.filter(v => v.option1 === style);
          const availableColors = [...new Set(matchingStyleVariants.map(v => v.option2))];

          let itemHTML = `
            <div class="form-selection-item">
              <div class="selection-main-item cart-item main-item" data-variant-id="${data.mainProduct.variant_id}">
                <div class="selection-item-media">
                  <div class="item-media-container">
                    <img src="${data.mainProduct.image}" alt="">
                  </div>
                </div>
                <div class="selection-item-details">
                  <div class="item-details-wrap">
                    <div class="item-remove-btn">
                    <span class="svg-wrapper">${closeSVG}</span>
                    </div>
                    <div class="item-detial-price-wrap">
                      <div class="item-detail-wrapper">

                        <div class="item-name h4">${data.mainProduct.title}</div>
                        <div class="item-options">
                          ${data.mainProduct.style ? `<div class="item-option" data-style="${data.mainProduct.style}"><span>Style:</span><span>${data.mainProduct.style}</span></div>` : ''}
                          ${data.mainProduct.color ? `<div class="item-option" data-color="${data.mainProduct.color}"><span>Color:</span><span>${data.mainProduct.color}</span></div>` : ''}
                          
                        </div>
                        <div class="item-qty">
                          <div class="item-qty-wrapper">
                            <label for="item-qunatity">Qty: </label>
                            <input type="number" id="item-quantity" name="Quantity" min="1" max="100" value="${data.mainProduct.quantity}">
                          </div>
                        </div>
                      </div>
                      <div class="item-price-wrapper">
                        <div class="itme-price"><span class="price">${formatPrice(data.mainProduct.price)}</span></div>
                      </div>
                    </div>
                    <div class="item-properties">
                      ${data.dimensions.map(d => `
                        <p>
                          <span><span>Qty:</span><span>${d.quantity}</span></span>
                          <span><span>Width:</span><span>${d.width}</span></span>
                          <span><span>Height: </span><span>${d.height}</span></span>
                          <span><span>Notes: </span><span>${d.notes}</span></span>
                        </p>`).join('')}
                    </div>
                  </div>
                </div>
              </div>
          `;
      
          // Only add sub-item HTML if hardwareProduct is not null
          
          if (data.hardwareProduct) {
            itemHTML += `
              <div class="selection-sub-item cart-item" data-variant-id="${data.hardwareProduct.variantId}">
                <div class="selection-sub-item-media">
                  <div class="item-media-container">
                    <img src="${data.hardwareProduct.image}" alt="">
                  </div>
                </div>
                <div class="selection-sub-item-details">
                  <div class="item-details-wrap">
                    <div class="item-remove-btn">
                    <span class="svg-wrapper">${closeSVG}</span>
                    </div>
                    <div class="item-detial-wrap">
                      <div class="item-name h4">${data.hardwareProduct.title}</div>
                      <div class="item-options">
                        <div class="item-option"><span>Color:</span><span>${data.hardwareProduct.color}</span></div>
                        <div class="item-option"><span>Size:</span><span>${data.hardwareProduct.size}</span></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            `;
          }
         if (data.mainProduct.type === "main") {
              // Start wrapper div
              itemHTML += `<div class="custom-edit-color-wrapper">`;

              // Edit Button
              itemHTML += `
                <div class="edit-btn" 
                    data-id="${data.mainProduct.variant_id}" 
                    data-item-style="${data.mainProduct.style}" 
                    data-item-title="${data.mainProduct.title}">
                  <button type="button">Add or Edit Selection</button>
                </div>
              `;

              // Add Color Options HTML right after Edit Button
              if (matchingStyleVariants.length > 1) {
                let colorOptionsHTML = `
                  <div class="product-color-options selected-item choose-cst-btn">
                    <button class="choose-color" type="button">Edit Color</button>
                    <div class="product-options">
                      <div class="pro-selector-color">
                        <div class="pro-option-colors product-form__input">
                `;

                matchingStyleVariants.forEach((variant, i) => {
                  const colorName = variant.option2;
                  const variantId = variant.id;
                  const imageUrl = variant.metafields?.color_image || '';
                  const safeId = `addon_${colorName.replace(/\s+/g, '_')}_${variantId}`;

                  colorOptionsHTML += `
                    <input class="swatch-input__input color_option"
                      type="radio"
                      id="${safeId}"
                      name="pro-option-color__${data.mainProduct.id}"
                      value="${colorName}"
                      data-variant-id="${variantId}">
                    <label for="${safeId}" class="swatch-input__label" title="${colorName}">
                      <span class="swatch"
                            data-img-url="${imageUrl}"
                            style="background-image:url('${imageUrl}')"></span>
                      <span class="swatch-text">${colorName}</span>
                    </label>
                  `;
                });

                colorOptionsHTML += `
                        </div>
                      </div>
                    </div>
                  </div>
                `;

                itemHTML += colorOptionsHTML;
              }

              // Close wrapper div
              itemHTML += `</div>`;
            }

          
          // itemHTML += `<div class="edit-btn" data-id="${data.mainProduct.variant_id}"><button type="button">Add or Edit Selection</button></div>`;
          itemHTML += `</div>`; // Close .form-selection-item
          outputHTML += itemHTML;
        }
      });
    
      
      cart_button.classList.remove("hidden");
      items_wrapper.innerHTML = outputHTML;
      items_wrapper.classList.remove("hidden");
      emptySelection.classList.add("hidden");
      
      var cart_remove_buttons = items_wrapper.querySelectorAll('.item-remove-btn');
      cart_remove_buttons.forEach(button => {
        button.addEventListener('click', function (e) {
          e.preventDefault();
          const cartItem = this.closest('.cart-item');
          const variantId = cartItem.getAttribute('data-variant-id');

          // Find and operate on a copy of allSelectedProducts so we mutate safely
          allSelectedProducts.forEach((item, idx) => {
            if (cartItem.classList.contains('selection-main-item')) {
              if (item.mainProduct && (item.mainProduct.variant_id === variantId || item.mainProduct.variantId === variantId)) {
                // Completely clear this selection's main/hardware/dimensions
                item.mainProduct = null;
                item.hardwareProduct = null;
                item.dimensions = []; // remove dimensions as well
              }
            } else if (cartItem.classList.contains('selection-sub-item')) {
              if (item.hardwareProduct && (item.hardwareProduct.variantId === variantId || item.hardwareProduct.variant_id === variantId)) {
                // remove hardware only
                item.hardwareProduct = null;
              }
            }
          });

          // Now remove any objects that have neither main nor hardware
          allSelectedProducts = allSelectedProducts.filter(item => {
            const hasMain = item.mainProduct && Object.keys(item.mainProduct).length > 0;
            const hasHardware = item.hardwareProduct && Object.keys(item.hardwareProduct).length > 0;
            return hasMain || hasHardware;
          });

          // Re-sync storage and UI safely
          localStorage.setItem("selectedProductData", JSON.stringify(allSelectedProducts));
          renderSelectionItems(allSelectedProducts);

          // update mobile button / cart visibility logic (keep your existing logic but run after render)
          var mobile_btn = orderForm.querySelector(".form__buttons-wrap-mobile button");
          var savedData = JSON.parse(localStorage.getItem('selectedProductData')) || [];
          if (Array.isArray(savedData) && savedData.length > 0) {
            allSelectedProducts = deepClone(savedData);
            renderSelectionItems(savedData);
            mobile_btn.removeAttribute('disabled');
            cart_button.classList.remove('hidden');
          } else {
            mobile_btn.setAttribute('disabled','disabled');
            cart_button.classList.add('hidden');
          }
        });
      });


      var selection_edit_btns = items_wrapper.querySelectorAll(".edit-btn");
      if(selection_edit_btns.length){
        selection_edit_btns.forEach((edit_btn)=>{
          edit_btn.addEventListener('click',function(){
            let variantId = edit_btn.getAttribute("data-id");
            let dimensionPopup = document.querySelector(".custom-form-popup.dimension");
            dimensionPopup.querySelector(".dimension-form-main").setAttribute("data-variant-id",variantId);
            
            dimensionPopup.classList.add("active");
            document.body.classList.add("popup-active");          
  
            orderForm.querySelector(".hardware-form-main").setAttribute("main-variant-id",variantId);
            // check if product already available in cart
            let editProduct = allSelectedProducts.find(product => product.mainProduct.variant_id === variantId);
            var form_body = dimensionPopup.querySelector(".form-body-wrap");
            if(editProduct){
              var min_width = editProduct.mainProduct.min_width;
              var max_width = editProduct.mainProduct.max_width;
              var min_height = editProduct.mainProduct.min_height;
              var max_height = editProduct.mainProduct.max_height;
    
              form_body.setAttribute("min_width",min_width);
              form_body.setAttribute("max_width",max_width);
              form_body.setAttribute("min_height",min_height);
              form_body.setAttribute("max_height",max_height);
              
              dimensionPopup.querySelector(".dimension-form-main .product-title").textContent = editProduct.mainProduct.title;
              if(editProduct.hardwareProduct == null){
                dimensionPopup.querySelector(".dimension-form-action.choose_hardware").classList.add('hidden');
                dimensionPopup.querySelector(".dimension-form-action.continue-action").classList.remove('hidden');
              } else {
                dimensionPopup.querySelector(".dimension-form-action.choose_hardware").classList.remove('hidden');
                dimensionPopup.querySelector(".dimension-form-action.continue-action").classList.add('hidden');
              }
              // console.log("editProduct",editProduct);
              // console.log("hardware product",editProduct.hardwareProduct);
              alreadyInCart(editProduct);
            }
            // change item-type in tooltip and qty selector msg
            // console.log("edit_btn.dataset.itemStyle",edit_btn.dataset.itemStyle,document.querySelectorAll(`.info-tooltip[data-tooltip-info="dimension"] item-type`));
            document.querySelectorAll(`.info-tooltip[data-tooltip-info="dimension"] item-type`).forEach(itemType => {
              itemType.innerHTML = edit_btn.dataset.itemStyle;
            });
            
            document.querySelectorAll(".pro-qty-selector-alert .item-type").forEach(itemT => {
              itemT.innerHTML = edit_btn.dataset.itemTitle;
            });
            
          });
        })
      }

      // Handle color change (alternative color selection)
      // Color option change event
items_wrapper.querySelectorAll('.color_option').forEach(input => {
  input.addEventListener('change', function () {
    const selectedColor = this.value;
    const newVariantId = this.dataset.variantId;

    // Find parent form-selection-item
    const parentItem = this.closest('.form-selection-item');
    if (!parentItem) return;

    // Get current variant ID of this item
    const currentVariantId = parentItem.querySelector('.selection-main-item').dataset.variantId;

    // Find the existing product in allSelectedProducts
    const existingProduct = allSelectedProducts.find(product => {
      return product.mainProduct && (
        product.mainProduct.variant_id == currentVariantId ||
        product.mainProduct.variantId == currentVariantId
      );
    });

    if (existingProduct) {
      console.log("Before update:", existingProduct);

      // Update mainProduct color and variant ID
      existingProduct.mainProduct.variant_id = newVariantId;
      existingProduct.mainProduct.color = selectedColor;

      // ✅ Get the color image URL from this input’s label
      const label = document.querySelector(`label[for="${this.id}"]`);
      const colorImageUrl = label ? label.querySelector('.swatch')?.dataset.imgUrl : '';
      existingProduct.mainProduct.color_image = colorImageUrl;

      // ✅ Save to localStorage
      localStorage.setItem("selectedProductData", JSON.stringify(allSelectedProducts));

      // ✅ Re-render updated selection items
      renderSelectionItems(allSelectedProducts);

      // ✅ After re-render, re-check the correct input
      setTimeout(() => {
        const updatedInput = document.querySelector(`.color_option[data-variant-id="${newVariantId}"]`);
        if (updatedInput) {
          updatedInput.checked = true;
          console.log("Checked restored for:", updatedInput.value);
        }
      }, 50);

      console.log("After update:", existingProduct);
    }
  });
});



      items_wrapper.querySelectorAll(".selected-item.choose-cst-btn").forEach(chooseColor =>{
        chooseColor.addEventListener('click',function(){
          const currentItem = this.closest(".form-selection-item");
          currentItem.querySelector(".product-options").classList.toggle("active");
        })      
      });



      var cartItems = items_wrapper.querySelectorAll(".cart-item");
      // console.log("cartItems",cartItems.length);
      if(cartItems.length < 1){
        // console.log("cart items length is less then 1");
        var selection_footer = document.querySelector(".form-selection-footer");
        // console.log("selection_footer",selection_footer);
        selection_footer.classList.add('hidden');
        document.querySelector(".order-form-selection .selection-empty").classList.remove('hidden');
      }

      if(allItems.length > 0){
        let hardwareProNotNull = allItems.filter(item => { return item.hardwareProduct != null });
        if(hardwareProNotNull.length > 0){
          // console.log("lastHarwareProObj",hardwareProNotNull);
          let lastHarwareProObj = hardwareProNotNull[hardwareProNotNull.length - 1].hardwareProduct;
          let title = `${lastHarwareProObj.size} - ${lastHarwareProObj.title}`;
          let image = lastHarwareProObj.image;
          document.querySelector("[data-hardware-item-prev-selection]").setAttribute("data-product-title",lastHarwareProObj.title);
          document.querySelector("[data-hardware-item-prev-selection]").setAttribute("data-product-color",lastHarwareProObj.color);
          document.querySelector("[data-hardware-item-prev-selection]").setAttribute("data-product-size",lastHarwareProObj.size);
          document.querySelector("[data-hardware-item-prev-selection] [data-hardware-item-prev-selection-image]").setAttribute("src",image);
          document.querySelector("[data-hardware-item-prev-selection] [data-hardware-item-prev-selection-title]").innerHTML = title;
          document.querySelector(".hardware-form")?.classList.add("hidden");
          document.querySelector(".hardware-form-alert")?.classList.remove("hidden");
        }
      }else{
        document.querySelector(".hardware-form")?.classList.remove("hidden");
        document.querySelector(".hardware-form-alert")?.classList.add("hidden");
      }
      
    } 
    // end - renderSelectionItems
    
   
    var mobile_btn = orderForm.querySelector(".form__buttons-wrap-mobile button");
    var savedData = JSON.parse(localStorage.getItem('selectedProductData'));

    // console.log("savedData",savedData);
    if (Array.isArray(savedData) && savedData.length > 0) {
      allSelectedProducts =  savedData;
      // console.log("called....");
      renderSelectionItems(savedData);
      mobile_btn.removeAttribute('disabled');
      cart_button.classList.remove('hidden');
    } else {
      mobile_btn.setAttribute('disabled','disabled');
      cart_button.classList.add('hidden');
    }

    var mobileViewSelection = orderForm.querySelector(".form__buttons-wrap-mobile .summary");
    if(mobileViewSelection){
      mobileViewSelection.addEventListener('click',function(){
        orderForm.querySelector(".order-form-grid-item.item-selection").classList.add('active');
      });
    }
    
    document.addEventListener("click", function (event) {
      const itemSelectionEl = orderForm.querySelector(".order-form-grid-item.item-selection");
      const isClickInside = event.target.closest('.item-selection .order-form-item-wrap');
      const isMobileButton = event.target.closest(".form__buttons-wrap-mobile .summary");
      // console.log("click");
      
      // Only remove the class if clicked outside item-selection
      if (!isClickInside && !isMobileButton) {
        itemSelectionEl.classList.remove('active');
      }
    });

    var hardwareSubmitButton = orderForm.querySelector(".hardware-form-main .action-button");
    hardwareSubmitButton.addEventListener('click',function(e){
      e.preventDefault();
      hardwarePopup.classList.remove('active');
      var hardwareForm = this.closest(".hardware-form-main");
      var variantId = this.getAttribute("data-variant-id");
      // var hardwareTitle = hardwareForm.querySelector(".form-pro-list-item.active .from-pro-item-title span").textContent;
      var hardwareTitle = document.querySelector(".form-product-options:not(.hidden) select").selectedOptions[0].dataset.proTitle;
      let optionSelector = hardwareForm.querySelector('.form-product-options:not(.hidden)');
      if(optionSelector){
        var selectedColor = optionSelector.querySelector("input.swatch-input__input:checked")?.value?.trim();
        var selectedValue = optionSelector.querySelector("#form-pro-style").value;
          // const selectedColor = selectedColorInput?.value?.trim();
      }
     
      // var hardwareImg = hardwareForm.querySelector(".form-pro-list-item.active .pro-item-image-wrap img").src;
      var hardwareImg = document.querySelector(".form-product-options:not(.hidden) .hardware-option-size-item.active img").src;
      // if(document.querySelector(".form-product-options:not(.hidden) select").selectedOptions[0].hasAttribute("data-group-product")){
      //   hardwareImg = document.querySelector(`[data-image-noscript]`).getAttribute(`data-image-variant-${variantId}`);
      // }
      var hardwareQunatity = hardwareForm.querySelector(".quantity__input").value;
      // console.log("hardwareQunatity",hardwareQunatity);
  
      var mainVariantId = hardwareForm.getAttribute("main-variant-id");
      // var existingProduct = allSelectedProducts.find(product => product.mainProduct.variant_id === mainVariantId);
      var existingProduct = allSelectedProducts.find(item => 
        item?.mainProduct && item.mainProduct.variant_id === mainVariantId
      );
        if(existingProduct){
          existingProduct.hardwareProduct = {};
          existingProduct.hardwareProduct = {
            title: hardwareTitle,
            quantity: hardwareQunatity,
            variantId: variantId,
            color: selectedColor,
             style: selectedValue,
            size: selectedValue,
            image:hardwareImg
          };
        } else {
          selectedProductData.hardwareProduct = {
            title: hardwareTitle,
            quantity: hardwareQunatity,
            variantId: variantId,
            color: selectedColor,
            size: selectedValue,
            image:hardwareImg
          };
        }
      
      // console.log("selectedProductData",selectedProductData);
     
      items_wrapper.classList.remove("hidden");
      emptySelection.classList.add("hidden");
      if (!existingProduct) {
        allSelectedProducts.push(selectedProductData);
      }

      console.log("selectedProductData",selectedProductData);
      console.log("allSelectedProducts",allSelectedProducts);

      localStorage.setItem("selectedProductData", JSON.stringify(allSelectedProducts));
      renderSelectionItems(allSelectedProducts);
      // console.log("allSelectedProducts",allSelectedProducts);
      var mobile_btn = orderForm.querySelector(".form__buttons-wrap-mobile button");
      var savedData = JSON.parse(localStorage.getItem('selectedProductData'));
      if (Array.isArray(savedData) && savedData.length > 0) {
        allSelectedProducts =  savedData;
        renderSelectionItems(savedData);
        mobile_btn.removeAttribute('disabled');
        cart_button.classList.remove('hidden');
      }else{
        mobile_btn.setAttribute('disabled','disabled');
        cart_button.classList.add('hidden');
      }
    }); 

    function handleAddToCartClick(e) {
      e.preventDefault();

      // checkbox is not check then provide alt meesage
      const framed = document.getElementById('framed');
      const frameless = document.getElementById('frameless');
      const designStyleElement = document.querySelector('.pro-option-design-style.product-form__input');
      const drillYesel = document.getElementById('drill-yes');
      const drillNoel = document.getElementById('drill-no');
      const drillElement = document.querySelector('.pro-option-drilled-fronts.product-form__input');
      const clrYesel = document.getElementById('color-Paint-yes');
      const clrNoel = document.getElementById('color-Paint-no');
      const clrElement = document.querySelector('.pro-option-color-Paint.product-form__input');
      const clrinput = document.querySelector('.pro-option-colors.product-form__input');
        
      let hasMainProduct = false;
      let hasnomainproduct = false;
      allSelectedProducts.forEach(product => {
        // console.log(allSelectedProducts);
        if (product?.mainProduct?.type === "main") {
          // console.log(hasnomainproduct,"true");
          hasMainProduct = true;
        }else{
          hasnomainproduct = true;
        }
      });

      if (!hasMainProduct) {
        e.preventDefault();
        alert('Please select at least one main product from Step 4 to continue.');
        return false;
      }
        
      if (!framed.checked && !frameless.checked) {
        e.preventDefault(); 
        // Add error class
        updateSpecificationHeaderStatus();
        designStyleElement.classList.add('select-frame');
        alert('Step 3 Specifications section is incomplete: You must complete all highlighted fields in order to continue.');
        return false;
      }

      // highly overlay validation 
      const hingeFrameless = document.getElementById('dimension-frameless');
      const hingeFramed = document.getElementById('dimension-frame');
      
      const framelessWrapper = hingeFrameless.closest('.pro-option-style-dimension.product-form__input');
      const framedWrapper = hingeFramed.closest('.pro-option-style-dimension.product-form__input');
      
      // Check if either dropdown is visible and has a selected value
      const framelessVisible = hingeFrameless && hingeFrameless.offsetParent !== null;
      const framedVisible = hingeFramed && hingeFramed.offsetParent !== null;
      
      const framelessValid = framelessVisible && hingeFrameless.value !== "";
      const framedValid = framedVisible && hingeFramed.value !== "";
      
      if (framelessValid && framedValid) {
        updateSpecificationHeaderStatus();
        if (framelessWrapper) framelessWrapper.classList.add('select-overlay');
        if (framedWrapper) framedWrapper.classList.add('select-overlay');
        alert('Step 3 Specifications section is incomplete: You must complete all highlighted fields in order to continue.');
        return false;
      } else {
        if (framelessValid && framelessWrapper) framelessWrapper.classList.remove('select-overlay');
        if (framedValid && framedWrapper) framedWrapper.classList.remove('select-overlay');
      }
      //  Check Pre Drilled Fronts
      if (!drillYesel.checked && !drillNoel.checked) {
        e.preventDefault(); 
        drillElement.classList.add('select-drill');
        updateSpecificationHeaderStatus();
        alert('Step 3 Specifications section is incomplete: You must complete all highlighted fields in order to continue.');
        return false;
      }

      if (!clrYesel.checked && !clrNoel.checked) {
        const bothDisabled = clrYesel.disabled && clrNoel.disabled;
        if (!bothDisabled) { 
          e.preventDefault(); 
          updateSpecificationHeaderStatus();
          clrElement.classList.add('add-color-paint');
          alert('Step 3 Specifications section is incomplete: You must complete all highlighted fields in order to continue.');
          return false;
        }
      }
      // Only show popup ONCE
      if (!hasnomainproduct){         
        const addonPopup = document.querySelector('.custom-form-popup.add-on-validation');
        // Check if popup has already been shown during this session
        if ( addonPopup && !sessionStorage.getItem('addonPopupShown')) {
          if (  !addonPopup.classList.contains('active')) {
            addonPopup.classList.add('active');
            // Mark as shown
            sessionStorage.setItem('addonPopupShown', 'true');
          }
          return false; // Prevent form submission
        }
      }
      //  Remove error class when user selects a Pre Drilled Fronts option
      [drillYesel, drillNoel].forEach((radio) => {
        radio.addEventListener('change', () => {
          if (drillYesel.checked || drillNoel.checked) {
            drillElement.classList.remove('select-drill');
          }
        });
      });
      
      //  Remove error class when user selects a Color Match Paint option
      [clrYesel, clrNoel].forEach((radio) => {
        radio.addEventListener('change', () => {
          if (clrYesel.checked || clrNoel.checked) {
            clrElement.classList.remove('add-color-paint');
          }
        });
      });

      // Remove error class if selection changes
      [framed, frameless].forEach(checkbox => {
        checkbox.addEventListener('change', () => {
          if (framed.checked || frameless.checked) {
            designStyleElement.classList.remove('select-frame');
          }
        });
      });
      // end logic of checkbox reduired

      // Get references
      const colorPaintCheckbox = document.getElementById('color-Paint');
      const colorPaintYesRadio = document.getElementById('color-Paint-yes');
      
      // Calculate total dimension quantity
      let totalDimensionQuantity = 0;
      document.querySelectorAll('.form-selection-item').forEach(item => {
        const qtyInput = item.querySelector('.item-qty input');
        const quantity = parseInt(qtyInput?.value) || 0;
        totalDimensionQuantity += quantity;
      });

      // Calculate total main product quantity
      let totalMainProductQuantity = 0;
      allSelectedProducts.forEach(product => {
        if (product?.mainProduct?.type === "main") {
          totalMainProductQuantity += parseInt(product.mainProduct.quantity || 0);
        }
      });
          
      const variantprice = '';
      // Paint variant object
      const paintVariantId = 44131611967661;
      const paintVariantObject = {
        variant: {
          variantId: paintVariantId,
          title: 'Color Matched Paint',
          type: 'variant',
          price : variantprice,
          image: 'https://cdn.shopify.com/s/files/1/0690/5489/0157/files/Paint.png?v=1738704925',
          quantity: totalMainProductQuantity
        }
      };
          
      // Check if paint variant already exists
      const existingIndex = allSelectedProducts.findIndex(
        item => item.variant && item.variant.variantId === paintVariantId
      );
      
      //  Only add/update if: radio is Yes AND checkbox is checked
      if (colorPaintYesRadio.checked ) {
        if (existingIndex === -1) {
          allSelectedProducts.push(paintVariantObject);
        } else {
          allSelectedProducts[existingIndex].variant.quantity = totalMainProductQuantity;
        }
      } else {
        //  Otherwise remove the paint variant if it exists
        if (existingIndex !== -1) {
          allSelectedProducts.splice(existingIndex, 1);
        }
      }

      // Store updated selections in localStorage
      localStorage.setItem("finalselectedProductData", JSON.stringify(allSelectedProducts));
      // console.log("Updated allSelectedProducts:", allSelectedProducts);

      const activeframeField = orderForm.querySelector(".order-form-specifications .frame-field.active");

      let selectedSpecifications = {};
      if (activeframeField) {
        const checkedDesignInput = document.querySelector(".order-form-specifications .pro-option-design-style input[type='radio']:checked");
        const selectElem = activeframeField.querySelector("select");
        const selectedSpecification = selectElem ? selectElem.value : null;
        const checkedDesign = checkedDesignInput ? checkedDesignInput.value : null;
    
        if (selectedSpecification) {

          selectedSpecifications["selected_specification"] = selectedSpecification;
        }
      
        if (checkedDesign) {
          selectedSpecifications["design_style"] = checkedDesign;
        }
      }
    
      const drillYes = document.querySelector("#drill-yes");
      const drillNo = document.querySelector("#drill-no");
      
      if (drillYes && drillYes.checked) {
        selectedSpecifications["pre_drilled_fronts"] = "Yes";
      } else if (drillNo && drillNo.checked) {
        selectedSpecifications["pre_drilled_fronts"] = "No";
      }

      const colorPaintYes = document.querySelector("#color-Paint-yes");
      const colorPaintNo = document.querySelector("#color-Paint-no");
      
      if (colorPaintYes && colorPaintYes.checked) {
        selectedSpecifications["color_match_paint"] = "Yes";
      } else if (colorPaintNo && colorPaintNo.checked) {
        selectedSpecifications["color_match_paint"] = "No";
      }
      
      // Now store this object into localStorage
      localStorage.setItem("selectedProductSpecifications", JSON.stringify(selectedSpecifications));
      
      // (Optional) Check if saved properly
      // console.log("Saved Specifications:", selectedSpecifications);
      window.location.href = '/pages/result-page';
    }
    
    cart_button.addEventListener('click', handleAddToCartClick);
    mobile_btn.addEventListener('click', handleAddToCartClick);

    // Start : Show Saved Draft Data
      const viewSavedDraftBtn = document.querySelector(".order-form-header-item .saved-draft");

      if (viewSavedDraftBtn) {
        console.log("window.savedDrafts",window.savedDrafts);
        if (!window.savedDrafts || Object.keys(window.savedDrafts).length === 0) {
          viewSavedDraftBtn.style.display = 'none';
        } else {
          viewSavedDraftBtn.style.display = '';
        }

        viewSavedDraftBtn.addEventListener('click', function () {
          if (window.savedDrafts && Object.keys(window.savedDrafts).length > 0) {
            const popup = document.querySelector(".custom-form-popup.saved-drafts");
            const draftPopupTitleElem = popup.querySelector(".form-header-inner .heading");
            const draftList = popup.querySelector(".draft-list");

            draftPopupTitleElem.textContent = "SAVED DRAFTS";
            draftList.innerHTML = "";

            // Header row
            const headerRow = document.createElement("div");
            headerRow.className = "draft-row draft-header";
            headerRow.innerHTML = `
              <div class="draft-col">Job Name</div>
              <div class="draft-col">Date</div>
              <div class="draft-col">Select</div>
            `;
            draftList.appendChild(headerRow);

            // console.log("window.savedDrafts",window.savedDrafts);
            // Dynamic draft rows
            Object.keys(window.savedDrafts).forEach((draftName) => {
              const draftEntry = window.savedDrafts[draftName];
              const draftDate = draftEntry?.date || "-";

              const row = document.createElement("div");
              row.className = "draft-row";
              row.innerHTML = `
                <div class="draft-col">${draftName}</div>
                <div class="draft-col">${draftDate}</div>
                <div class="draft-col button-with-icon">
                  <button class="draft-title-btn" data-draft="${draftName}">Open Order 
                  </button>
                  <button class="remove-draft-btn">
                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                      <g clip-path="url(#clip0_703_279)">
                      <path d="M21.7407 2.99182H18.0009V2.24386C18.0009 1.0066 16.9943 0 15.757 0H9.77339C8.53613 0 7.52953 1.0066 7.52953 2.24386V2.99182H3.78976C2.55249 2.99182 1.5459 3.99841 1.5459 5.23568C1.5459 6.22936 2.19537 7.0737 3.09192 7.3679L4.42602 23.4726C4.52211 24.6264 5.50432 25.5302 6.6621 25.5302H18.8683C20.0261 25.5302 21.0084 24.6264 21.1045 23.4722L22.4385 7.36785C23.335 7.0737 23.9845 6.22936 23.9845 5.23568C23.9845 3.99841 22.9779 2.99182 21.7407 2.99182ZM9.02544 2.24386C9.02544 1.83144 9.36097 1.49591 9.77339 1.49591H15.757C16.1694 1.49591 16.505 1.83144 16.505 2.24386V2.99182H9.02544V2.24386ZM19.6137 23.3484C19.5816 23.733 19.2543 24.0343 18.8683 24.0343H6.6621C6.27621 24.0343 5.9488 23.733 5.91684 23.3488L4.60224 7.47954H20.9282L19.6137 23.3484ZM21.7407 5.98363H3.78976C3.37734 5.98363 3.04181 5.6481 3.04181 5.23568C3.04181 4.82326 3.37734 4.48772 3.78976 4.48772H21.7407C22.1531 4.48772 22.4886 4.82326 22.4886 5.23568C22.4886 5.6481 22.1531 5.98363 21.7407 5.98363Z" fill="#FF0000"/>
                      <path d="M9.77177 21.7443L9.02382 9.67729C8.99824 9.26497 8.64136 8.95138 8.23104 8.97706C7.81871 9.00264 7.50522 9.35757 7.53075 9.76984L8.27871 21.8369C8.30329 22.2334 8.63259 22.5386 9.02452 22.5386C9.45768 22.5386 9.79835 22.1738 9.77177 21.7443ZM12.765 8.97566C12.352 8.97566 12.0171 9.31054 12.0171 9.72362V21.7906C12.0171 22.2037 12.352 22.5386 12.765 22.5386C13.1781 22.5386 13.513 22.2037 13.513 21.7906V9.72362C13.513 9.31054 13.1781 8.97566 12.765 8.97566ZM17.299 8.97711C16.8876 8.95153 16.5317 9.26502 16.5062 9.67734L15.7582 21.7443C15.7328 22.1566 16.0463 22.5115 16.4585 22.5371C16.8711 22.5626 17.2258 22.249 17.2513 21.8369L17.9993 9.76989C18.0248 9.35757 17.7113 9.00264 17.299 8.97711Z" fill="#FF0000"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_703_279">
                      <rect width="25.5302" height="25.5302" fill="white"/>
                      </clipPath>
                      </defs>
                    </svg>
                  </button>
                </div>
              `;
              draftList.appendChild(row);
            });

            popup.classList.add("active");

            // Remove draft logic
            draftList.addEventListener('click', function (e) {
              const removeBtn = e.target.closest('.remove-draft-btn');
              if (!removeBtn) return;

              const rowElem = removeBtn.closest('.draft-row');
              const draftName = rowElem.querySelector('.draft-col:first-child')?.textContent.trim();
              if (!draftName) return;

              delete window.savedDrafts[draftName];
              localStorage.setItem("draftSelections", JSON.stringify(window.savedDrafts));
              rowElem.remove();

              // console.log("window.customer_id = {{ customer.id }};",window.customer_id);
              // Update metafield on server
              const url = 'https://dddemo.net/php/2025/sandip/rafecekit/update_metafield.php?customer_id=' + window.customer_id;
              fetch(url, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(window.savedDrafts)
              })
              .then(response => {
                if (!response.ok) {
                  console.error("Request failed with status:", response.status);
                  return;
                }
                // console.log("Request successful!");
                return response.json();
              })
              .then(data => {
                if (data) {
                  console.log("Response data:", data);
                }
              })
              .catch(error => {
                console.error("Network error:", error);
              });

              if (!Object.keys(window.savedDrafts).length) {
                popup.classList.remove("active");
                viewSavedDraftBtn.style.display = 'none';
              }
            });
          }
        });
      } 
    // End : Show Saved Draft Data


    // Close Saved Draft and Draft alert Popup
    document.addEventListener("click", e => {
      const savedPopup = document.querySelector(".custom-form-popup.saved-drafts.active");
      if (savedPopup) {
        const content = savedPopup.querySelector(".dimension-form-main");
        if (savedPopup === e.target || (!content.contains(e.target) && savedPopup.contains(e.target))) {
          savedPopup.classList.remove("active");
        }
      }

      const alertPopup = document.querySelector(".custom-form-popup.draft-alert.active");
      if (alertPopup) {
        const content = alertPopup.querySelector(".dimension-form-main");
        if (alertPopup === e.target || (!content.contains(e.target) && alertPopup.contains(e.target))) {
          alertPopup.classList.remove("active");
        }
      }
    });

    // document.addEventListener("click", (e) => {
    //   const openBtn = e.target.closest(".draft-title-btn");
    //   if (!openBtn) return;

    //   // console.log("clicked....");

    //   const draftName = openBtn.dataset.draft;
    //   const draftObj = window.savedDrafts[draftName];
    //   const draftData = draftObj?.data || [];

    //   console.log("Current allSelectedProducts before merge:", allSelectedProducts);
    //   console.log("Draft Data:", draftData);

    //   // Pull existing selections from localStorage just in case
    //   const existingData = localStorage.getItem("selectedProductData");
    //   let existingSelections = existingData ? JSON.parse(existingData) : [];

    //   // 🟢 Helper function — merges drafts with existing products
    //   function mergeDraftWithExisting(existing, draft) {
    //     const merged = [...existing];

    //     draft.forEach((draftItem) => {
    //       const existingIndex = merged.findIndex(
    //         (item) =>
    //           item.category === draftItem.category &&
    //           item.mainProduct === draftItem.mainProduct &&
    //           item.variantId === draftItem.variantId
    //       );

    //       if (existingIndex !== -1) {
    //         // If already exists, merge their data
    //         merged[existingIndex] = {
    //           ...merged[existingIndex],
    //           ...draftItem,
    //           dimensions: draftItem.dimensions || merged[existingIndex].dimensions,
    //           notes: draftItem.notes || merged[existingIndex].notes,
    //           qty: draftItem.qty || merged[existingIndex].qty,
    //         };
    //       } else {
    //         // Otherwise, push new one
    //         merged.push(draftItem);
    //       }
    //     });
    //     return merged;
    //   }

    //   if (existingSelections.length > 0) {
    //     const alertPopup = document.querySelector(".custom-form-popup.draft-alert");
    //     alertPopup.classList.add("active");

    //     const appendBtn = alertPopup.querySelector(".append-draft");
    //     const resetBtn = alertPopup.querySelector(".reset-draft");

    //     appendBtn.replaceWith(appendBtn.cloneNode(true));
    //     resetBtn.replaceWith(resetBtn.cloneNode(true));

    //     const newAppendBtn = alertPopup.querySelector(".append-draft");
    //     const newResetBtn = alertPopup.querySelector(".reset-draft");

    //     // Append (merge) data
    //     newAppendBtn.addEventListener("click", () => {
    //       const merged = mergeDraftWithExisting(existingSelections, draftData);

    //       // Update globals + localStorage
    //       allSelectedProducts = merged;
    //       localStorage.setItem("selectedProductData", JSON.stringify(allSelectedProducts));

    //       // Re-render merged data
    //       renderSelectionItems(allSelectedProducts);

    //       alertPopup.classList.remove("active");
    //       document.querySelector(".custom-form-popup.saved-drafts").classList.remove("active");
    //     });

    //     // Replace (overwrite)
    //     newResetBtn.addEventListener("click", () => {
    //       allSelectedProducts = [...draftData];
    //       localStorage.setItem("selectedProductData", JSON.stringify(allSelectedProducts));

    //       renderSelectionItems(allSelectedProducts);

    //       alertPopup.classList.remove("active");
    //       document.querySelector(".custom-form-popup.saved-drafts").classList.remove("active");
    //     });
    //   } else {
    //     // No existing data — directly load draft
    //     allSelectedProducts = [...draftData];
    //     localStorage.setItem("selectedProductData", JSON.stringify(allSelectedProducts));

    //     renderSelectionItems(allSelectedProducts);
    //     document.querySelector(".custom-form-popup.saved-drafts").classList.remove("active");
    //   }
    // });
    document.addEventListener("click", (e) => {
      const openBtn = e.target.closest(".draft-title-btn");
      if (!openBtn) return;

      const draftName = openBtn.dataset.draft;
      const draftObj = window.savedDrafts[draftName];
      console.log("draftObj",draftObj);

      const savedSpecifications = draftObj.specification;

      console.log("savedSpecifications",savedSpecifications);

      const draftData = draftObj?.data || [];

      const isMain = draftData[0].mainProduct;

      let color = null;
      let style = null;

      if (isMain) {
        color = isMain.color;
        style = isMain.style;
      }

      // console.log("Color:", color);
      // console.log("Style:", style);

      const existingData = localStorage.getItem("selectedProductData");
      let existingSelections = existingData ? JSON.parse(existingData) : [];

      const autoSelectStyle = () => {
        if (!style) return;
        // Wait briefly to ensure DOM is updated
        setTimeout(() => {
          const styleOption = document.querySelector(`.pro-style-option-single[data-value="${style}"]`);
          if (styleOption) {
            styleOption.click();
            // console.log(`Auto-selected style: ${style}`);
          } else {
            // console.warn(`No matching style option found for: ${style}`);
          }
        }, 300); // adjust delay if needed
      };

      const autoSelectColor = () => {
        if (!color) return;
        setTimeout(() => {
          const colorOption = document.querySelector(`.pro-option-colors .swatch-input__input[value="${color}"]`);
          if (colorOption) {
            colorOption.click();
            // console.log(`Auto-selected color: ${color}`);
          } else {
            // console.warn(`No matching color option found for: ${color}`);
          }
        }, 300);
      };

      if(savedSpecifications){
        const designStyle = savedSpecifications.design_style;
        const savedStyleize = savedSpecifications.selected_specification;

        let selectElement = null;
        const designInputs = document.querySelectorAll('.form-spec-grid-item .pro-option-design-style input[type="radio"]');
        // console.log("designInputs",designInputs);
        designInputs.forEach(input => {
          if (input.value.toLowerCase() == designStyle?.toLowerCase()) {
            input.checked = true;
          }
        });

        const framedSelect = document.querySelector(".pro-option-style-dimension .dimension-frame-field");
        const framelessSelect = document.querySelector(".pro-option-style-dimension .dimension-frameless-field");
        
        if(designStyle == 'framed'){
          framedSelect.style.display = 'block';
          framelessSelect.style.display = 'none';
          selectElement = framedSelect.querySelector('#dimension-frame');
        }else if(designStyle == 'frameless'){
          framedSelect.style.display = 'none';
          framelessSelect.style.display = 'block';
          selectElement = framelessSelect.querySelector('#dimension-frameless');
        }
        if (selectElement) {
          const options = selectElement.options;
          for (let i = 0; i < options.length; i++) {
            if (options[i].value.replace(/&quot;/g, '"') === savedStyleize) {
              selectElement.selectedIndex = i;
              break;
            }
          }
        }

        if (savedSpecifications.pre_drilled_fronts === "Yes") {
          const drillYes = document.getElementById('drill-yes');
          if (drillYes) {
            drillYes.checked = true;
          }
        } else if (savedSpecifications.pre_drilled_fronts === "No") {
          const drillNo = document.getElementById('drill-no');
          if (drillNo) {
            drillNo.checked = true;
          }
        }

        if (savedSpecifications.color_match_paint === "Yes") {
          const colorMatchYes = document.querySelector('#color-Paint-yes');
          if (colorMatchYes) {
            colorMatchYes.checked = true;
          }
        } else if (savedSpecifications.color_match_paint === "No") {
          const colorMatchNo = document.querySelector('#color-Paint-no');
          if (colorMatchNo) {
            colorMatchNo.checked = true;
          }
        }
      }

      // If some selection already exists in cart
      if (existingSelections.length > 0) {
        const alertPopup = document.querySelector(".custom-form-popup.draft-alert");
        alertPopup.classList.add("active");

        const appendBtn = alertPopup.querySelector(".append-draft");
        const resetBtn = alertPopup.querySelector(".reset-draft");

        // reset old event listeners
        appendBtn.replaceWith(appendBtn.cloneNode(true));
        resetBtn.replaceWith(resetBtn.cloneNode(true));

        const newAppendBtn = alertPopup.querySelector(".append-draft");
        const newResetBtn = alertPopup.querySelector(".reset-draft");

        // Append data (merge with existing)
        newAppendBtn.addEventListener("click", () => {
          const merged = mergeDraftWithExisting(existingSelections, draftData);
          allSelectedProducts = merged.map(item => deepClone(item));

          localStorage.setItem("selectedProductData", JSON.stringify(allSelectedProducts));
          renderSelectionItems(allSelectedProducts);
          autoSelectStyle();
          autoSelectColor();

          alertPopup.classList.remove("active");
          document.querySelector(".custom-form-popup.saved-drafts").classList.remove("active");
        });

        // Replace data (load draft only)
        newResetBtn.addEventListener("click", () => {
          allSelectedProducts = draftData.map(item => deepClone(item));

          localStorage.setItem("selectedProductData", JSON.stringify(allSelectedProducts));
          renderSelectionItems(allSelectedProducts);
          autoSelectStyle();
          autoSelectColor();

          alertPopup.classList.remove("active");
          document.querySelector(".custom-form-popup.saved-drafts").classList.remove("active");
        });
      } else {
        // No existing data — load directly
        allSelectedProducts = draftData.map(item => deepClone(item));

        localStorage.setItem("selectedProductData", JSON.stringify(allSelectedProducts));
        renderSelectionItems(allSelectedProducts);
        autoSelectStyle();
        autoSelectColor();

        document.querySelector(".custom-form-popup.saved-drafts").classList.remove("active");
      }
    });



  }
});


// check a same variant on cart variant change event
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.pro-option-colors input[type="radio"]:checked').forEach(radio => {
    radio.checked = false;
  });
  // const styleSelect = document.querySelector('.pro-selector-type select');
  // const selectedColorInput = document.querySelector('.swatch-input__input:checked');
  // updateBanner(styleSelect, selectedColorInput);

  const verifyPopup = document.querySelector('.verify-popup');
  const styleSelect = document.querySelector('#pro-style');
  const colorRadios = document.querySelectorAll('input[name="pro-option-color"]');

  let selectedStyle = styleSelect?.value || null;
  let selectedColor = document.querySelector('input[name="pro-option-color"]:checked')?.value || null;

  const updatePopupStatus = () => {
    const items = document.querySelectorAll('.selection-main-item.cart-item.main-item');

    if (items.length === 0) {
      verifyPopup?.classList.remove('open-popup');
      return;
    }

    const allMatch = [...items].every(item => {
      const style = item.querySelector('.item-option[data-style]')?.dataset.style;
      const color = item.querySelector('.item-option[data-color]')?.dataset.color;
      return selectedStyle === style && selectedColor === color;
    });

    verifyPopup?.classList.toggle('open-popup', allMatch);
  };

  styleSelect?.addEventListener('change', e => {

    selectedStyle = e.target.value;
    updatePopupStatus();
    // checkIfHardwareExists();

  });

  colorRadios.forEach(radio =>
    radio.addEventListener('change', e => {
      if (e.target.checked) {
        selectedColor = e.target.value;
        updatePopupStatus();
      }
    })
  );

  updatePopupStatus(); // Initial check on load
});

// On page load: check which color is selected and apply logic
// document.addEventListener('DOMContentLoaded', function () {
//   const selectedColorInput = document.querySelector('.swatch-input__input:checked');
//   if (selectedColorInput) {
//     handlePaintReadyDisabling(selectedColorInput.value);
//   }
// });


  // variant selected verify popup

    document.querySelector('.btn-cancel')?.addEventListener('click', () => {
      document.querySelector('.verify-popup').classList.remove('open-popup');
    });
    
    document.querySelector('.btn-continue')?.addEventListener('click', () => {
      document.querySelectorAll('.selection-main-item .item-remove-btn').forEach(btn => {
        btn.click(); // Trigger click on each remove button
      });
      document.querySelector('.verify-popup').classList.remove('open-popup');
    });

    // pop-up close js if variant is already added
    document.querySelector('.type-validation .btn-cancel')?.addEventListener('click', () => {
      document.querySelector('.custom-form-popup.type-validation')?.classList.remove('active');
    });

    document.querySelector('.type-validation .btn-continue')?.addEventListener('click', () => {
      document.querySelector('.custom-form-popup.type-validation')?.classList.remove('active');
    });

    document.querySelector('.custom-form-popup.type-validation')?.addEventListener('click', function (e) {
      const dimensionMain = this.querySelector('.dimension-form-main');
 
      if (!dimensionMain.contains(e.target)) {
        this.classList.remove('active');
      }
    });

    // add-on product pop-up close 
    document.querySelector('.custom-form-popup.add-on-validation')?.addEventListener('click', function (e) {
      const addonpopup = this.querySelector('.dimension-form-main');
      if (!addonpopup.contains(e.target)) {
        this.classList.remove('active');
      }
    });

    // add-on accordian auto-open 
    document.querySelector('.add-on-validation .add-on-item')?.addEventListener('click', function () {
      // 1. Hide the popup
      document.querySelector('.custom-form-popup.add-on-validation')?.classList.remove('active');

      // 2. Target the accordion heading
      const addonHeader = document.querySelector('.form-selector-header.add-on-accordian.acco-head');
    
      if (addonHeader) {
        // Add active class
        addonHeader.classList.add('active');

        // Open its content (next sibling)
        const addonContent = addonHeader.nextElementSibling;
        if (addonContent && addonContent.style.display !== 'block') {
          $(addonContent).slideDown();
        }

        // Optional: close other accordions if needed
        $('.acco-head').not(addonHeader).each(function () {
          const otherContent = $(this).next();
          if (otherContent.is(':visible')) {
            otherContent.slideUp();
            $(this).removeClass('active');
          }
        });
      }
    });

    //add-on accordian continue button
    document.addEventListener("DOMContentLoaded", function () {
      const addonPopup = document.querySelector('.custom-form-popup.add-on-validation');
      const form = document.querySelector('form'); // Replace with your actual form selector
      const cancelButton = document.querySelector('.add-on-cancel'); // Class for your cancel button

      if (!form || !addonPopup) return;

      form.addEventListener('submit', function (e) {
        if (!sessionStorage.getItem('addonPopupShown')) {
          e.preventDefault(); // Stop form submission
          addonPopup.classList.add('active'); // Show popup
          sessionStorage.setItem('addonPopupShown', 'true'); // Mark as shown
        }
      });

      // Handle cancel button click to close popup
      if (cancelButton) {
        cancelButton.addEventListener('click', function () {
          addonPopup.classList.remove('active');
          document.querySelector(".order-form-selection .form-selection-footer")?.click();
        });
      }
    });

    // Optional: reset on reload
    window.addEventListener('beforeunload', function () {
      sessionStorage.removeItem('addonPopupShown');
    });

    // remove class after select value 
    const dimensionFrame = document.getElementById('dimension-frame');
    const dimensionFrameless = document.getElementById('dimension-frameless');
    const hingeWrapper = document.querySelector('.pro-option-style-dimension.product-form__input');

    // Listen for changes on both dropdowns
    dimensionFrame?.addEventListener('change', function() {
        hingeWrapper.classList.remove('select-overlay');
    });

    dimensionFrameless?.addEventListener('change', function() {
        hingeWrapper.classList.remove('select-overlay');
    });
 
  // tooltip pop
  const tooltippopup = document.querySelector('.custom-form-popup.tooltip-popup');
  const formBodyWrap = tooltippopup?.querySelector('.form-body-wrap');
  document.querySelectorAll('[data-tooltip]').forEach(function (tooltipTrigger) {
    tooltipTrigger.addEventListener('click', function (event) {
      const tooltipKey = this.getAttribute('data-tooltip');

      // SPECIAL CASE: specifications-hinge
      if (tooltipKey === 'specifications-hinge') {
        const framed = document.getElementById('framed');
        const frameless = document.getElementById('frameless');

        if (!framed.checked && !frameless.checked) {
          alert('Please select either Framed or Frameless before viewing hinge overlay information.');
          return; // Exit if neither is selected
        }

        // Show correct section based on selection
        const actionFramed = tooltippopup.querySelector('.tooltip-action-framed');
        const actionFrameless = tooltippopup.querySelector('.tooltip-action-frameless');

        if (framed.checked) {
          actionFramed.style.display = 'block';
          actionFrameless.style.display = 'none';
        } else {
          actionFramed.style.display = 'none';
          actionFrameless.style.display = 'block';
        }
      }

      tooltippopup?.classList.add('active');

      const allTooltips = tooltippopup.querySelectorAll('.info-tooltip');
      allTooltips.forEach(function (tooltip) {
        tooltip.style.display = (tooltip.getAttribute('data-tooltip-info') === tooltipKey) ? 'block' : 'none';
      });

      event.stopPropagation();
    });
  });

  document.addEventListener('click', function (event) {
    const clickedInsideForm = formBodyWrap?.contains(event.target);
    const clickedTooltipIcon = event.target.closest('[data-tooltip]');
    // console.log("clickedInsideForm",clickedInsideForm,"clickedTooltipIcon",clickedTooltipIcon);
    if (!clickedInsideForm && !clickedTooltipIcon) {
      tooltippopup?.classList.remove('active');
    }
  });

  // calculation for framed hinge overlay
  function calculateHingeOverlay() {
    const doorWidthInput = document.getElementById('door-width');
    const openingWidthInput = document.getElementById('opening-width');
    const resultSpan = document.querySelector('.result-count');
    const select = document.getElementById('dimension-frame');

    // Create error message container if not present
    let errorMsg = document.querySelector('.overlay-error-msg');
    if (!errorMsg) {
      errorMsg = document.createElement('p');
      errorMsg.className = 'overlay-error-msg';
      errorMsg.style.color = 'red';
      errorMsg.style.marginBottom = '10px';

      const resultWrap = document.querySelector('.result-wrap');
      resultWrap?.parentElement?.insertBefore(errorMsg, resultWrap);
    }

    // Convert decimal to nearest nice fraction string (like 1 1/4")
    function decimalToFractionString(decimal) {
    const whole = Math.floor(decimal);
    const fraction = decimal - whole;

    const fractions = [
      { val: 0, str: '' },
      { val: 0.125, str: '1/8"' },
      { val: 0.25, str: '1/4"' },
      { val: 0.375, str: '3/8"' },
      { val: 0.5, str: '1/2"' },
      { val: 0.625, str: '5/8"' },
      { val: 0.75, str: '3/4"' },
      { val: 0.875, str: '7/8"' },
      { val: 1, str: '' } // roll up to next inch
    ];

    let closest = fractions.reduce((prev, curr) => {
      return Math.abs(curr.val - fraction) < Math.abs(prev.val - fraction) ? curr : prev;
    });

    let result = '';
    if (closest.val === 1) {
      result = (whole + 1) + '"';
    } else if (closest.val === 0) {
      result = whole + '"'; // <-- fix added here to ensure " is added
    } else if (whole === 0) {
      result = closest.str;
    } else {
      result = `${whole} ${closest.str}`;
    }

    return result.trim();
  }

  // Safe expression evaluator (handles inputs like 2 - 1/2)
  function evalSafe(expr) {
    try {
      return Function(`"use strict"; return (${expr})`)();
    } catch {
      return NaN;
    }
  }

  function updateResult() {
    const doorWidth = evalSafe(doorWidthInput.value);
    const openingWidth = evalSafe(openingWidthInput.value);

    if (!isNaN(doorWidth) && !isNaN(openingWidth)) {
      const overlayDecimal = (doorWidth - openingWidth) / 2;
      const overlayFractionString = decimalToFractionString(overlayDecimal);

      resultSpan.textContent = overlayFractionString;

      let matched = false;
      for (let i = 0; i < select.options.length; i++) {
        const opt = select.options[i].value.replace(/&quot;/g, '"');
        if (opt === overlayFractionString) {
          select.selectedIndex = i;
          matched = true;
          break;
        }
      }

      if (!matched) {
        select.selectedIndex = 0;
        errorMsg.textContent = `RefaceKit offers five hinge overlays: ½”, ¾”, 1”, 1 ¼ and 1⅜”. These cover more than 99% of all hinges. Please double check your measurements.`;
      } else {
        errorMsg.textContent = '';
      }
     if (overlayDecimal === 0) {
        select.selectedIndex = 0;
       resultSpan.textContent = '0';
        errorMsg.textContent = `RefaceKit offers five hinge overlays: ½”, ¾”, 1”, 1 ¼ and 1⅜”. These cover more than 99% of all hinges. Please double check your measurements.`;
      } 


    } else {
      resultSpan.textContent = '-';
      errorMsg.textContent = '';
      select.selectedIndex = 0;
    }
  }

  doorWidthInput?.addEventListener('input', updateResult);
  openingWidthInput?.addEventListener('input', updateResult);
}

  document.addEventListener('DOMContentLoaded', calculateHingeOverlay);


  document.querySelectorAll('.floating-style-tooltip').forEach((tooltip) => {
    tooltip.addEventListener('click', () => {
      if (window.innerWidth <= 989) {
        const popup = document.querySelector('.custom-form-popup.mobile-order-form-image');
        if (popup) {
          popup.classList.add('active');
        }
      }
    });
  });

  document.querySelector('.custom-form-popup.mobile-order-form-image')?.addEventListener('click', function (e) {
    const innerBox = this.querySelector('.order-form-image-main');

    if (!innerBox.contains(e.target)) {
      this.classList.remove('active');
    }
  });

  //  auto-open accordian after select value 
  function updateStyleHeaderStatus(selectedStyle) {
      // console.log("updateStyleHeaderStatus");
    if (!selectedStyle) return;
  
    const $accoHeadings = $('.acco-head');
    const $targetHeadercolor = $('.form-selector-header.color-accordian');
    const $targetContent = $targetHeadercolor.next();
  
    // Remove active class and hide content of other sections
    $accoHeadings.not($targetHeadercolor).each(function () {
      const $otherContent = $(this).next();
      if ($otherContent.is(':visible')) {
        $otherContent.slideUp(1000);
        $(this).removeClass('active');
      }
    });
    // Add active class and show content for target section
    $targetHeadercolor.addClass('active');
    $('.order-form-pro-selector.pro-color-selector').removeClass('disabled');
    $targetContent.slideDown();
  }

  // auto-open specification accordian 
  function updateSpecificationHeaderStatus() {
    // console.log("updateSpecificationHeaderStatus");
    const $accoHeadings = $('.acco-head');
    const $targetHeaderSpec = $('.form-specification-header.acco-head');
    const $targetContent = $targetHeaderSpec.next();

    if(!document.querySelector(".order-form-pro-selector.pro-color-selector .acco-head").classList.contains("prevent-click")){    
      // Remove active class and hide content of other sections
      $accoHeadings.not($targetHeaderSpec).each(function () {
        // console.log("updateSpecificationHeaderStatus inside");
        const $otherContent = $(this).next();
        if ($otherContent.is(':visible')) {
          $otherContent.slideUp(1000);
          $(this).removeClass('active');
        }
      });
  
      // Add active class and show content for target section
      $targetHeaderSpec.addClass('active');
      $targetHeaderSpec.removeClass('disabled');
      $targetContent.slideDown();
    }
  }

  // open add products accordian on full fil specification form 
  function checkDesignStyleAndOpenAccordioncolor() {
    const anyChecked = $('input[name="Design Style"]:checked').length > 0;
    const anyChecked2 = $('input[name="pre_drilled_fronts"]:checked').length > 0;
    const anyChecked3 = $('input[name="color-Paint"]:checked').length > 0;
    const frameValue = $('#dimension-frame').val();
    const framelessValue = $('#dimension-frameless').val();
  
    const hasSelection = frameValue !== null && frameValue !== "" || framelessValue !== null && framelessValue !== "";
    if (anyChecked && anyChecked2 && anyChecked3 && hasSelection ) {
      const $header = $('.selction-accordian');
      const $content = $header.next('.acco-content');
      const $otherContent = $(this).next();
      if (!$header.hasClass('active')) {
        $header.addClass('active');
        $header.removeClass('disabled');
        $content.stop(true, true).slideDown();
      }
    }
  }

  //  on check of specifications
  function checkDesignStyleAndOpenAccordion() {
    // console.log("checkDesignStyleAndOpenAccordion>>>>>>");
    const anyChecked = $('input[name="Design Style"]:checked').length > 0;
    const anyChecked2 = $('input[name="pre_drilled_fronts"]:checked').length > 0;
    let anyChecked3 = $('input[name="color-Paint"]:checked').length > 0;
    const frameValue = $('#dimension-frame').val();
    const framelessValue = $('#dimension-frameless').val();
  
    const hasSelection = (frameValue !== null && frameValue !== "") || (framelessValue !== null && framelessValue !== "");

    if(document.querySelector('.pro-color-selector .pro-selector-color input:checked').value == "Paint-Ready") anyChecked3 = true;
  
    if (anyChecked && anyChecked2 && anyChecked3 && hasSelection) {
      const $header = $('.selction-accordian');
      const $content = $header.next('.acco-content');
  
      // Close all other accordions before opening this one
      $('.acco-head').not($header).each(function () {
        const $otherContent = $(this).next('.acco-content');
        if ($otherContent.is(':visible')) {
          $otherContent.slideUp(500);
          $(this).removeClass('active');
        }
      });
  
      // Open target accordion if not already open
      if (!$header.hasClass('active')) {
        $header.addClass('active').removeClass('disabled');
        $content.stop(true, true).slideDown(500);
      }
    }
  }

  // faq accordian js
    $(document).ready(function() {
      function faqAccordion() {
        let $accoHeadings = $('.acco-head');
        $accoHeadings.off('click').on('click', function() {
          // console.log("$accoHeadings clicked");
          // if(!$(this).hasClass("prevent-click")){
          let $selectHeading = $(this);
          let $selectedContent = $selectHeading.next();
    
          $accoHeadings.not($selectHeading).each(function() {
            let $otherContent = $(this).next(); 
            if ($otherContent.is(':visible')) {
              $otherContent.slideUp();
              $(this).removeClass('active');
            }
          });
          $selectedContent.slideToggle();
          $selectHeading.toggleClass('active');
          // }
        });
      }
      faqAccordion();
      
    });
  // faq accordian js

  // color image click event
    var colorImageArr = document.querySelectorAll(".pro-style-options-wrap .pro-style-option-single");
    colorImageArr.forEach(cImg => {
      cImg.addEventListener("click",function(e){
        e.preventDefault();
        // console.log("door style clicked");
        localStorage.selectedDoorStyle = cImg.dataset.value;
        if(document.querySelector("item-pro-type")) document.querySelector("item-pro-type").innerHTML = cImg.dataset.value;
        document.querySelector(".pro-style-options-wrap .pro-style-option-single.active")?.classList.remove("active");
        this.classList.add("active");
        document.querySelectorAll(`[name="pro-style"]`).forEach(select => {
          select.value = cImg.dataset.value;
          select.dispatchEvent(new Event('change'));
        });
        // setTimeout(() => {
        //   // document.querySelectorAll(`.info-tooltip[data-tooltip-info="dimension"] item-type`).forEach(itemType => {
        //   //   itemType.innerHTML = document.querySelector(`[name="pro-style"]`) ? document.querySelector(`[name="pro-style"]`).value : "";
        //   // });
        //   document.querySelectorAll(".pro-qty-selector-alert .item-type").forEach(itemT => {
        //     itemT.innerHTML = cImg.dataset.value;
        //   });
        // },2000);
        // //  Page load: Apply step 2 - color from localStorage if exists
        // let localColor = localStorage.selectedColor;
        // if(localColor != "" && localColor != undefined){
        //   document.querySelectorAll(`.pro-color-selector .pro-option-colors input:checked`).forEach(color => {
        //     color.removeAttribute("checked");
        //   });
        //   document.querySelectorAll(`.pro-color-selector .pro-option-colors input[value="${localColor}"]`).forEach(color => {
        //     color.checked = true;
        //     // color.dispatchEvent(new Event('change'));
        //   });
        // }
      });
    });

  // size image click event - in popup
  var sizeImageArr = document.querySelectorAll(".hardware-option-size-list [data-option-size-item]");
  sizeImageArr.forEach(cImg => {
    cImg.addEventListener("click",function(e){
      e.preventDefault();
      this.closest(".hardware-option-size-list").querySelector("[data-option-size-item].active")?.classList.remove("active");
      this.classList.add("active");
      this.closest(".pro-selector-type").querySelector(`select[name="form-pro-style"]`).value = this.dataset.value;
      this.closest(".pro-selector-type").querySelector(`select[name="form-pro-style"]`).dispatchEvent(new Event('change'));
    });
  });

  // repeat selection
  let repeatSelection = document.querySelector("[data-hardware-item-prev-selection]") || null;
  if(repeatSelection){
    repeatSelection.addEventListener("click",function(e){
      e.preventDefault();
      // document.querySelector(".hardware-form-alert")?.classList.add("hidden");
      // document.querySelector(".hardware-form")?.classList.remove("hidden");
      
      // console.log("aaaa",document.querySelector(`.hardware-option-single[data-product-title="${this.dataset.productTitle}"]`));
      document.querySelector(`.hardware-option-single[data-product-title="${this.dataset.productTitle}"]`)?.click();
      setTimeout(() => {
        document.querySelector(`.form-product-options:not(.hidden) .pro-option-colors input[value="${this.dataset.productColor}"]`)?.click();
      },200);
      setTimeout(() => {
        document.querySelector(`.form-product-options:not(.hidden) .hardware-option-size-list .hardware-option-size-item[data-value='${this.dataset.productSize}']`)?.click();
      },400);
      setTimeout(() => {
        document.querySelector(`.hardware-action-button`)?.click();
      },1000);
    });
  }

  // make new selection - data-hardware-item-new-selection
  let newSelection = document.querySelector("[data-hardware-item-new-selection]") || null;
  if(newSelection){
    newSelection.addEventListener("click",function(e){
      e.preventDefault();
      document.querySelector(".hardware-form-alert")?.classList.add("hidden");
      document.querySelector(".hardware-form")?.classList.remove("hidden");
    });
  }

  // data-form-reset -- start
    let formResetAlertArr = document.querySelectorAll("[data-form-reset-alert],[data-reset-order-alert-close]");
    formResetAlertArr.forEach(btn => {
      btn.addEventListener("click",function(e){
        e.preventDefault();
        document.querySelector(".custom-form-popup.reset-order-alert").classList.toggle("active");
      });
    });

    let formReset = document.querySelector("[data-form-reset]") || null;
    if(formReset){
      formReset.addEventListener("click",function(e){
        e.preventDefault();
        localStorage.removeItem("selectedProductData");
        localStorage.removeItem("finalselectedProductData");
        localStorage.removeItem("selectedDoorStyle");
        localStorage.removeItem("selectedColor");
        localStorage.removeItem("selectedProductSpecifications");
        setTimeout(() => {
          location.reload();
        },500);
      });
    }

  // data-form-reset -- end


  // Start clear cart logic

    let clearCart = document.querySelector(".order-form-clear[data-form-clear]") || null;
    if(clearCart){
      clearCart.addEventListener("click",function(e){
        e.preventDefault();
        localStorage.removeItem("selectedProductData");
        localStorage.removeItem("finalselectedProductData");
        localStorage.removeItem("selectedDoorStyle");
        localStorage.removeItem("selectedColor");
        localStorage.removeItem("selectedProductSpecifications");
        setTimeout(() => {
          location.reload();
        },500);
      });
    }
  // End cart-clear logic

  // back-to-dimension
  let backToDimension = document.querySelector(".back-to-dimension") || null;
  if(backToDimension){
    backToDimension.addEventListener("click",function(e){
      e.preventDefault();
      document.querySelector(".custom-form-popup.hardware").classList.remove("active");
      setTimeout(() => {
      document.querySelector(".custom-form-popup.dimension").classList.add("active");
      },500);
    });
  }

  // START :--- Order Result page 

    document.addEventListener("DOMContentLoaded", function() {
      const addedProducts = localStorage.getItem("finalselectedProductData");
      var savedSelections = JSON.parse(addedProducts);

      const savedSpecifications = localStorage.getItem("selectedProductSpecifications");
      var savedSpecificationsData = JSON.parse(savedSpecifications);

      const selectionItemsContainer = document.querySelector('.form-selection-items');
      const selectionEmpty = document.querySelector('.selection-empty');
      const selectionFooter = document.querySelector(".form-selection-footer");

      // saveAsDraft Button 
        const saveASDraftButtons = document.querySelectorAll(".save-as-draft.save-for-later");
        saveASDraftButtons.forEach((saveAsDraftBtn) => {
          saveAsDraftBtn.addEventListener('click', function(e) {
            e.preventDefault();
            const jobName = prompt("Enter a job name for this draft:");
            if (!jobName) return;

            const drafts = JSON.parse(localStorage.getItem("draftSelections")) || {};
            // console.log("Drafts",drafts);

            // Format today's date as MM-DD-YYYY
            const today = new Date();
            const year = String(today.getFullYear()).slice(-2);
            const formattedDate = `${String(today.getDate()).padStart(2, '0')}/${String(today.getMonth() + 1).padStart(2, '0')}/${year}`;
            // console.log(formattedDate);
            
            // Save current selections as draft
            drafts[jobName] = {
              date: formattedDate,
              data: savedSelections,
              specification : savedSpecificationsData
            };

            const url = 'https://dddemo.net/php/2025/sandip/rafecekit/update_metafield.php?customer_id=' + window.customer_id;
            fetch(url, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(drafts)
            })
            .then(res => res.json())
            .then(resp => console.log("Response from:", url, resp))
            .catch(err => console.error("Error sending to:", url, err));

            // Store drafts back
            localStorage.setItem("draftSelections", JSON.stringify(drafts));

            // Reset current savedSelections
            savedSelections = [];
            localStorage.setItem("finalselectedProductData", JSON.stringify(savedSelections));
            localStorage.setItem("selectedProductData",JSON.stringify(savedSelections));

            // selectionItemsContainer.innerHTML = '';
            // renderHtml(savedSelections);
            selectionItemsContainer.classList.add('hidden');
            selectionFooter.classList.add('hidden');
            selectionEmpty.style.display = 'block';
          });
        });
      // saveAsDraft Button

      // Specification block
        const selectedSpecifications = JSON.parse(localStorage.getItem("selectedProductSpecifications"));
        // console.log("selectedSpecifications",selectedSpecifications);
        if (selectedSpecifications && Object.keys(selectedSpecifications).length === 0) {
          var specificationBlock = document.querySelector(".order-form-specifications");
          if(specificationBlock){
            specificationBlock.style.display = 'none';
          }
        } else {
          if(selectedSpecifications) {
            const designStyle = selectedSpecifications.design_style;
            const selectedSpecification = selectedSpecifications.selected_specification; 
            // console.log("designStyle",designStyle);
            
            let selectElement = null;
            const framedSelect = document.querySelector(".order-form-result-main .dimension-frame-field");
            const framelessSelect = document.querySelector(".order-form-result-main .dimension-frameless-field");
            
            if(designStyle == 'framed'){
              if(framedSelect){
                framedSelect.style.display = 'block';
                selectElement = framedSelect.querySelector('#dimension-frame');
              } 
              if(framelessSelect) framelessSelect.style.display = 'none';
             
            }else if(designStyle == 'frameless'){
              if(framedSelect) framedSelect.style.display = 'none';
              if(framelessSelect){
                framelessSelect.style.display = 'block';
                selectElement = framelessSelect.querySelector('#dimension-frameless');
              } 
            }
            
            const designInputs = document.querySelectorAll('.order-form-result-main .pro-option-design-style input[type="radio"]');
            designInputs.forEach(input => {
              if (input.value.toLowerCase() === designStyle?.toLowerCase()) {
                input.checked = true;
              }
            });
            
            if (selectElement) {
              const options = selectElement.options;
              for (let i = 0; i < options.length; i++) {
                if (options[i].value.replace(/&quot;/g, '"') === selectedSpecification) {
                  selectElement.selectedIndex = i;
                  break;
                }
              }
            }
            
            if (selectedSpecifications.pre_drilled_fronts === "Yes") {
              const drillYes = document.getElementById('drill-yes');
              if (drillYes) {
                drillYes.checked = true;
              }
            } else if (selectedSpecifications.pre_drilled_fronts === "No") {
              const drillNo = document.getElementById('drill-no');
              if (drillNo) {
                drillNo.checked = true;
              }
            }
            
            if (selectedSpecifications.color_match_paint === "Yes") {
              const colorMatchYes = document.querySelector('#color-Paint-yes');
              if (colorMatchYes) {
                colorMatchYes.checked = true;
              }
            } else if (selectedSpecifications.color_match_paint === "No") {
              const colorMatchNo = document.querySelector('#color-Paint-no');
              if (colorMatchNo) {
                colorMatchNo.checked = true;
              }
            }

            // new specifinations
            const designStyleElement = document.querySelector("[data-designstyle]");
            if (designStyleElement) designStyleElement.innerHTML = designStyle;

            const hingeElement = document.querySelector("[data-hinge]");
            if (hingeElement) hingeElement.innerHTML = selectedSpecification;

            const colorMatchedPaintElement = document.querySelector("[data-color-matched-paint]");
            if (colorMatchedPaintElement)
              colorMatchedPaintElement.innerHTML =
                selectedSpecifications.color_match_paint === "Yes" ? "Included" : "Not Included";

            const preDrilledDrawersElement = document.querySelector("[data-pre-drilled-drawers]");
            if (preDrilledDrawersElement)
              preDrilledDrawersElement.innerHTML =
                selectedSpecifications.pre_drilled_fronts === "Yes" ? "Included" : "Not Included";


          }
        }
      // Specification block
    });


  
  // END :--- Order Result page 

  window.addEventListener("pageshow", function () {
  const navEntries = performance.getEntriesByType("navigation");
  const navType = navEntries.length ? navEntries[0].type : null;

  if (navType === "back_forward") {
    console.log("Back/Forward button detected — refreshing...");
    window.location.reload();
  }
});